/* eslint-disable no-trailing-spaces,no-useless-escape */
import assign from "lodash/assign";
import config from "js/main/config";
import log from "js/main/log";
import localeStore from "js/stores/localeStore";
import HostHeader from "js/views/host/HostHeader";
const lang = localeStore.lang;
const nbsp = String.fromCharCode(160);
const s = "  ";

/* Deutsch*/
const localeDE = {
  delimiter: ",",
  lang: "de",
  monthNames: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ],
  dayNames: [
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag",
    "Sonntag",
  ],
  formatDate: function (date) {
    const d = new Date(date);
    return `${d.getDate()}. ${
      locale.de.monthNames[d.getMonth()]
    } ${d.getFullYear()}`;
  },

  whatsapp: {
    headline: "Fragen? WhatsApp senden.",
  },

  // misc
  notfound: "Seite nicht gefunden",
  error: "Fehler",
  note: "Hinweis",
  hello: "Hallo",
  welcome: "Willkommen",
  ok: "Ok",
  cancel: "Abbrechen",
  yes: "Ja",
  no: "Nein",
  next: "Weiter",
  saveAndContinue: "Speichern & Weiter",
  previous: "Zurück",
  print: "Drucken",
  required: "Pflichtfeld",
  edit: "Bearbeiten",
  save: "Speichern",
  editEntry: "Eintrag bearbeiten",
  saveEntry: "Eintrag speichern",
  removeEntry: "Eintrag löschen",
  sendPerMail: "Per E-Mail zusenden",
  pleaseChoose: "Bitte auswählen",
  saveSuccess: "Erfolgreich gespeichert",
  saveFailure: "Speichern fehlgeschlagen",
  loadMore: "Mehr Einträge laden",
  more: "mehr",

  // translation
  translateToGerman: "Auf Deutsch übersetzen",
  translateToEnglish: "Auf Englisch übersetzen",

  // userChat
  contactUs: "Schreiben sie uns",

  // calendar
  today: "Heute",
  pastDate: "In der Vergangenheit",

  // reservationCalendar
  reserved: "ausgebucht",
  noBooking: "Keine Buchung möglich",
  minBooking: "Minimaler Buchungszeitraum",
  maxBooking: "Maximaler Buchungszeitraum",
  inBooking: "Im Buchungszeitraum",
  bookingBegin: "Buchungsanfang",
  bookingEnd: "Buchungsende",
  bookingTimespan: "Buchungszeitraum",
  blockingTimespan: "Übernachtung nicht möglich",

  // static menu
  weAboutUs: "Wir über uns",
  contact: "Kontakt",
  bookingProcess: "Buchungsablauf",
  visit: "Besichtigung",
  arrivalInfo: "Info zu Anreise",
  hostInfo: "Info für Gastgeber",
  relocation: "Relocation + Visum & Wohnsitzanmeldung leicht gemacht",

  // frontPage Search
  search: "Suchen",
  roomtypeNumber: "Unterkunft-Id",
  enterRoomtypeNumber: "Ich kenne meinen Gastgeber (Unterkunft-Id)",
  roomtypeTooltip:
    "Hinweis: Die Unterkunft-Id wurde ab dem Relaunch der Website neu vergeben. Falls Sie das Objekt nicht in der Filtersuche finden, erfragen Sie bitte einfach per E-Mail (info@urbanbnb.de) die neue Nummer.",
  findRoomtype: "Unterkunft finden",
  roomtypeExists: "Unterkunft existiert",
  roomtypeNotFound: "Es existiert keine Unterkunft mit dieser Nummer!",
  onlineDiscountTooltip:
    "So geht's: Zimmer oder Wohnung aussuchen - online buchen und 5% Rabatt auf den Übernachtungspreis erhalten.",
  onlineDiscountMsg: "Online Buchen und 5% sparen",
  moveInImmediately: "Sofort Buchen",

  // results
  chooseCity: "Stadt wählen",
  noSearchResults:
    "In diesem Zeitraum sind in dem gewählten Bereich, leider keine Unterkünfte frei. \nBitte geben Sie ein späteres Datum ein oder erweitern Sie Ihre Suchkriterien im Filter.",
  chooseCityMsg:
    "Bitte wählen Sie eine Stadt aus oder wählen Sie die Ihrem Ziel nächstgelegene Adresse, die Ihnen vorgeschlagen wird.",
  results: "Ergebnisse",
  printResults: "Ergebnisse drucken",
  addRoomtypeToFavorites: "Diese Unterkunft zur Merkliste hinzufügen.",
  noGoogleMapsCookieSetInfoText:
    "Der Dienst für Google-Maps ist aktuell auf dieser Seite gesperrt!",
  noYoutubeCookieSetInfoText:
    "Der Dienst für Youtube ist aktuell auf dieser Seite gesperrt!",
  setGoogleMapsCookie: "Google Maps Dienst jetzt zulassen",
  setYoutubeCookie: "Youtube Dienst jetzt zulassen",

  setMapBoxCookie: "MapBox Dienst jetzt zulassen",
  mapBoxCookieNotAllowed: "MapBox Cookie nicht gesetzt",
  // header
  guestLogin: "Gastlogin",
  trustAndSecurity: "Vertrauen und Sicherheit",
  guestArea: "Gastbereich",
  becomeHost: "werden Sie Gastgeber",
  mdLoginBecomeHost:
    "Einfach und sicher vermieten mit einem starken Familienunternehmen an Ihrer Seite",
  becomeHostNow: "Jetzt kostenlos inserieren",

  // callcenterMode
  confirmAll: "Alle übernehmen",
  sendOffer: "Angebot senden",

  // offer
  availableFavorites: (available, total) =>
    `Im ausgewählten Zeitraum sind ${available} ihrer ${total} Unterkünfte auf der Merkliste verfügbar.`,

  // guestheader
  myData: "Meine Daten",
  accountData: "Accountdaten",
  guestFaq: "Gast-FAQ",

  // hostheader
  hostLogin: "Gastgeberlogin",
  hostArea: "Gastgeberbereich",
  hostFaq: "Gastgeberinfos und FAQ",
  hostNews: "Gastgebernews",
  downloadCenter: "Download-Center",

  // footer
  guestTos: "AGB's für Gäste",
  privacyPolicy: "Datenschutzerklärung",
  rightOfWithdrawal: "Widerrufsrecht für Verbraucher",
  stuttgartInfo: "Stuttgart Info",
  berlinInfo: "Berlin Info",
  karlsruheInfo: "Karlsruhe Info",
  cologneInfo: "Köln Info",
  imprint: "Impressum",

  // guestlogin
  mdGuestTeaser: `Hier bitte als **Gast** registrieren  
  oder einloggen und Unterkünfte  
  finden!`,

  // hostlogin - redesign
  hostHeader1:
    "WG-Zimmer, möblierten Appartements, Ferienwohnungen, Monteurunterkünfte, Serviced Apartments, Pensionen – jetzt rentabel möbliert vermieten!",
  hostHeader2_1: "Ich bin",
  hostHeader2_2: "Claudia Urban",
  hostHeader2_3:
    "Ihre Expertin für möbliertes Zeitwohnen für Geschäftsreisende.",
  hostHeader3:
    "Ich zeige Ihnen, wie Sie ein erfolgreicher Gastgeber:in für Wohnen auf Zeit werden und unterstütze Sie dabei, Ihre Immobilie optimal auszulasten.",
  hostHeader4:
    "Urbanbnb – Ihr Familienunternehmen seit 1996 die Profis für Zeitwohnen.",

  hostSubnav1: "Profitabel vermieten – so geht’s",
  hostSubnav2: "Erfolgsrezept Zeitwohnen",
  hostSubnav3: "Podcast",
  hostSubnav4: "Über mich",
  hostSubnav5: "Blog Gastgeberthemen",

  hostSection1_1:
    "Wohnen auf Zeit ist kein Trend, sondern mittlerweile eine etablierte Wohnlösung für Geschäftsreisende und alle, die eine Zwischenlösung benötigen. Profitieren Sie als Gastgeberin für Zeitwohnen von dieser Entwicklung. Vermieten Sie lukrativ an Firmen und Geschäftsreisende und genießen Sie die vielen Vorteile als Gastgeberin für möblierte Wohnungen und Zimmer.",
  hostSection1Headline: "Was kann Urbanbnb für Sie tun?",
  hostSection1_2:
    "Als Familienunternehmen für Wohnen auf Zeit verfügen wir über ein enormes Potenzial an Erfahrung in der Branche der Kurzzeitvermietung. Wir sind erfolgreich in der Vermittlung von möblierten WG-Zimmern, Apartments und Monteurunterkünften. Als familiengeführtes Unternehmen legen wir großen Wert darauf, keine anonyme Onlineplattform zu sein, sondern pflegen persönliche Kontakte zu Gästen und Gastgeberin, sind damit nah und erreichbar.",
  hostSection1_3:
    "Wir kennen die Branche Zeitwohnen wie unsere Westentasche. Dadurch sind wir in der Lage, unseren Gastgeberinnen wertvolle Tipps für die Preisfindung der Immobilie zu liefern, eine Marktanalyse der gefragtesten Standorte für die Kurzzeitvermietung anzubieten, die perfekte Möblierung zu finden oder zu beraten, ob die Immobilie am besten als WG-Zimmer oder als Wohnung genutzt werden sollte. Wir wissen, was auf dem Markt Zeitwohnen gefragt ist.",

  hostSection2Headline: "Profitabel vermieten – so geht’s",
  hostSection2_1:
    "Sind Sie ambitionierter Vermieterin von Ferienwohnungen, Serviced Apartments, Monteurunterkünften, WG-Zimmern oder Pensionen? Oder haben Sie Interesse daran, in diese spannende Branche der Zeitvermietung einzusteigen? Unsere Plattform bietet Ihnen die Möglichkeit, Ihre Unterkünfte einem breiten Publikum zugänglich zu machen und so Ihre Auslastung zu optimieren.",
  hostSection2_2:
    "Ich unterstütze Sie bei der Kurzzeitvermietung von möbliertem Wohnraum und zeige Ihnen, worauf Sie achten müssen, um mehr Umsatz zu erzielen, den Stress zu reduzieren und gute Bewertungen von Ihren Gästen zu erhalten. Werden Sie Teil unserer Community und steigern Sie Ihren Erfolg im Vermietungsgeschäft!",
  hostSection2_3:
    "Erfahren Sie auch, warum Ihr Erfolg als Gastgeberin eng mit der passenden Möblierung Ihrer Immobilie verbunden ist und einen wesentlichen Einfluss auf deren Auslastung hat. Und entdecken Sie, warum es für Sie als Gastgeberin entscheidend ist, Ihre Zielgruppe genau zu kennen und gezielt anzusprechen. Ich berate Sie bei der Auswahl des Standorts für Ihre Immobilie zur Nutzung für Kurzzeitvermietung und zeige Ihnen Möglichkeiten auf, wie Sie Ihren eigenen Aufwand für die Gästeabwicklung effizient halten können.",
  hostSection2Button: "Vereinbaren Sie einen kostenlosen Gesprächstermin",

  hostSection3Headline:
    "Interesse, Ihre Einnahmen und Attraktivität als Gastgeber zu steigern?",
  hostSection3_1:
    "Entdecken Sie die Geheimnisse erfolgreichen Zeitwohnens! Erfahren Sie, warum die Vermietung an Geschäftsreisende besonders lukrativ ist und wie Sie Ihre Immobilie optimal für kurzfristige Vermietungen nutzen können. Von der richtigen Einrichtung bis hin zur gezielten Ansprache Ihrer Zielgruppe – wir zeigen Ihnen, wie Sie Ihre Einnahmen steigern und gleichzeitig die Zufriedenheit Ihrer Gäste erhöhen können.",
  hostSection3_2:
    "Warum es besser ist, sich auf monatliche Vermietungen an Geschäftsreisende zu konzentrieren:",
  hostSection3Panel1Headline: "Einhaltung gesetzlicher Bestimmungen",
  hostSection3Panel1:
    "Durch die Vermietung auf monatlicher Basis an Geschäftsreisende vermeiden Sie mögliche Probleme mit dem Zweckentfremdungsgesetz, dass die kurzfristige Vermietung von Wohnraum reguliert.",
  hostSection3Panel2Headline: "Stabilität statt Stress",
  hostSection3Panel2:
    "Entdecken Sie, warum die monatliche Vermietung an Geschäftsreisende Ihrem Immobiliengeschäft langfristig mehr Ruhe und höhere Einnahmen bringt!",
  hostSection3Panel3Headline: "Ruhe und Ordnung",
  hostSection3Panel3:
    "Die monatliche Vermietung sind in der Regel ruhiger und ordentlicher als Touristen oder Partygäste, was zu einer angenehmeren Wohnatmosphäre führt.",
  hostSection3Panel4Headline: "Firmengäste",
  hostSection3Panel4:
    "Geschäftsreisende, die Ihre Immobilie für längere Aufenthalte nutzen, sind oft professionelle und zuverlässige Gäste, die die Ruhe und Privatsphäre schätzen. Indem Sie sich auf monatliche Vermietungen an Geschäftsreisende konzentrieren, können Sie Ihren Aufwand reduzieren und gleichzeitig stabile Einnahmen generieren. Erfahren Sie mehr über die Vorteile dieses Ansatzes und wie Sie erfolgreich in der Kurzzeitvermietung tätig sein können.",
  hostSection3Headline_2:
    "Maximieren Sie Ihre Einnahmen und Attraktivität als Gastgeber!",
  hostSection3_3:
    "Profitieren Sie von unserem Stammkundenpotenzial, anstatt selbst nach Gästen zu suchen. Als führende Plattform im Bereich möbliertes Zeitwohnen für Geschäftsreisende verfügt unser Familienunternehmen Urbanbnb über eine breite Palette von Stammfirmen, die regelmäßig bei uns nach Unterkünften suchen. Indem Sie Ihre Immobilie über Urbanbnb vermieten, können Sie von dieser etablierten Kundenbasis profitieren und stabile Einnahmen generieren. Erfahren Sie mehr über bewährte Strategien, die Ihnen helfen, in der lukrativen Welt des Zeitwohnens erfolgreich zu sein.",
  hostSection3Button: "Vereinbaren Sie einen kostenlosen Gesprächstermin",

  hostSection4Headline: "Unser Podcast",
  hostSection4Text:
    "Willkommen zum Vermieter-Podcast für alle, die möblierte WG-Zimmer, Apartments, Ferienwohnungen, Monteurzimmer und Serviced Apartments vermieten möchten! Hier erhalten Sie wertvolle Tipps, Ratschläge und Einblicke, um Ihre Vermietungserfahrung zu optimieren und erfolgreich zu sein. Von der Einrichtung und Vermarktung bis hin zur Gästebetreuung – lassen Sie sich von Expertenwissen inspirieren und nehmen Sie Ihre Vermietung auf ein neues Niveau!",
  hostSection4Button: "Coming Soon",

  hostSectionAboutus1Headline:
    "Urbanbnb – ein erfolgreiches Familienunternehmen für Wohnen auf Zeit seit 1996!",
  hostSectionAboutus1Text:
    "Seit über zwei Jahrzehnten setzen wir Maßstäbe in der Branche des möblierten Zeitwohnens. Unser Ansatz ist frisch und innovativ: persönlich, nahbar und stets erreichbar für unsere Gäste und Gastgeberinnen. Entdecken Sie, wie wir Ihnen helfen können, Ihre Immobilie optimal zu nutzen und gleichzeitig die Zufriedenheit Ihrer Gäste zu maximieren.",
  hostSectionAboutus2Headline: "Claudia Urban",
  hostSectionAboutus2Text1:
    "Gründerin von Urbanbnb und Expertin sowie Visionärin für möblierte Vermietung.",
  hostSectionAboutus2Text2:
    "Meine Vision war und ist es, Menschen in einer fremden Stadt ein Zuhause zu geben. Seit mehr als 27 Jahren arbeite ich mit großer Freude und Motivation daran und habe Urbanbnb zu einer führenden Plattform für zeitgemäßes Wohnen gemacht. Mein Engagement und Fachwissen treiben Innovationen voran, um sowohl Gastgeberinnen als auch Gästen eine einzigartige und bereichernde Erfahrung zu bieten. Ich stehe für höchste Standards in der Branche und teile gerne meine Expertise, um Ihnen bei der erfolgreichen Vermietung zu unterstützen.",
  hostSectionAboutus2Text3:
    "Dank meiner engen Kontakte zu verschiedenen Unternehmen kenne ich die Anforderungen für die Anmietung möblierter Wohnungen für deren Mitarbeiter. Ich setze diese Wünsche und Anforderungen entsprechend mit meinen Gastgeberinnen um, was zu einer erfolgreichen Vermietung auf Zeit führt.",
  hostSectionAboutus2Text4:
    "So geht erfolgreiche Kurzeitvermietung – mit einem erfahrenen Profi an Ihrer Seite ein Kinderspiel!",

  hostSection5Headline: "3 Topgründe für die Kurzzeitvermietung!",
  hostSection5Text1: "Hohe Mieteinnahmen durch Kurzzeitvermietung",
  hostSection5Text2: "Jederzeit schnellen Zugriff auf die Immobilie",
  hostSection5Text3: "Gäste Zielgruppe definieren können",

  hostSection6Headline: "Wir begrüßen Sie auf unserem Portal",
  hostSection6Button: "Lernen Sie uns kennen",

  hostSection7Headline: "Und das sagen unsere Gastgeber",
  hostSection7Button: "mehr lesen",

  hostSection8Headline:
    "Ratgeberbücher für Vermieter für Wohnen auf Zeit und alle, die es werden wollen!",

  hostSection9Headline: "Mit Urbanbnb wird Gastgeber werden zum Kinderspiel!",
  hostSection9Button: "Vereinbaren Sie einen kostenlosen Gesprächstermin",

  hostSection10Headline1: "Kurze Frage, schnelle Antwort?",
  hostSection10Text1: "Wir sind per WhatApp für Sie da:",
  hostSection10Phone: "+ 49 (0) 1520 2105848",

  hostSection10Headline2: "Lieber eine Mail schreiben?",
  hostSection10Text2: "Auch kein Problem:",
  hostSection10Mail: "info@urbanbnb.de",

  // hostlogin
  login: "Log In",
  register: "Registrieren",
  registerHost: "Jetzt Gastgeber werden",
  registerGuest: "Neuanmeldung Gast",
  advertiseForFree: "Inserieren Sie Ihr Objekt kostenlos!",
  weDoThatForYou: "Das tun wir für Sie",
  tipsForHosts: "Tipps für Gastgeber",
  topicHospitality: "Thema Gastfreundschaft",
  faqForHosts: "FAQ",
  faqForHostsSubHeadline: "Oft Gestellte Fragen unserer Gastgeber",
  rentDifferent:
    'Mit Urbanbnb Ihre freien Zimmer, Unterkünfte und Ferienwohnungen "anders vermieten"!',
  mdLoginMsg1: `Die steigende Mobilität der Menschen am Arbeitsmarkt erhöht weiter die Nachfrage nach flexiblen Übernachtungskonzepten in Deutschland. Möblierte Gästezimmer und Ferienwohnungen in Grossstädten sind gefragter denn je. Daher ist Bnb in Deutschland weiterhin auf Wachstumskurs. Profitieren Sie davon. Das Vermieten möblierter Wohnungen und die Untervermietung von Zimmern sichern einen attraktiven Nebenverdienst. Besser als jeder Nebenjob. Verdienen Sie bares Geld mit Ihrem Wohnraum. Lassen Sie Ihr Gästezimmer oder Ihre Wohnung nicht ungenutzt, sondern vermieten Sie bei Bedarf ganz entspannt an Geschäftsreisende und Stadtbesucher. Und das Beste, der Aufwand möbliert zu vermieten ist denkbar klein und übersichtlich. Auch Sie können sich nebenher ein gutes Geld verdienen – mit einer zeitweisen Vermietung anstatt dauerhaft.`,
  urbanbnbAdvantages:
    "Viele Vorteile bei Urbanbnb sind ganz offensichtlich. Sie bleiben als Urbanbnb Gastgeber völlig ungebunden und damit frei, mit weiteren Anbietern zusammenzuarbeiten. Auch die Zeiten, in denen Sie Ihre privaten Unterkünfte vermieten möchten, sind von Ihnen als Urbanbnb Gastgeber frei wählbar. Ganz gleich, ob Sie ihr Zimmer oder die möblierte Wohnung nur innerhalb der Woche, eines Monats oder aber ausschließlich an den Wochenenden vermieten möchten: Sie selbst entscheiden, für wann Sie die Zimmer oder Wohnungen als buchbar im Terminkalender eintragen möchten. Das Beste an der Sache: Sie müssen nicht auf Ihr Geld warten und auch nicht hinterherlaufen, weil Sie Ihr Geld für die Übernachtung immer bei Anreise bar von Ihrem Gast erhalten. Beim Vermieten von möblierten Wohnungen erzielen Sie außerdem eine höhere Miete als bei einer unmöblierten Dauervermietung.",
  expectFromUsTitle: "DAS KÖNNEN SIE VON UNS ERWARTEN:",
  expectFromUsArticle_1_SubHeadline: "Persönlich für Sie da",
  expectFromUsArticle_1_Text:
    "Als Urbanbnb Gastgeber können Sie sich darauf verlassen, dass Sie immer einen persönlichen und erreichbaren Ansprechpartner haben. Bei uns ist der Gastgeber keine „Nummer“, die im Portal angelegt ist, sondern ein geschätzter Partner. Wir sorgen nicht nur für eine perfekte Auslastung Ihrer Wohnung, sondern sind auch während der gesamten Anmietung Ihrer Gäste weiterhin an Ihrer Seite. Wir lassen Sie nicht allein.",
  expectFromUsArticle_2_SubHeadline:
    "Profitieren Sie von unserem Stammkundenpotenzial",
  expectFromUsArticle_2_Text:
    "Urbanbnb arbeitet seit 1996 im Bereich Wohnen auf Zeit. Mit den Jahren zählen wir sehr viele nationale und internationale Firmen zu unseren Stammkunden. Und wir kennen unsere Gäste. Wir wissen genau, welcher Gast am besten in welches Objekt passt. Das können Sie nur von einem Unternehmen erwarten, dass nicht den Überblick verliert und nah am Kunden ist. Als kleines, aber leistungsstarkes Familienunternehmen sind wir sehr nah am Geschehen. Profitieren Sie von unseren Erfahrungen auf dem Markt für Wohnen auf Zeit.",
  expectFromUsArticle_3_SubHeadline:
    "Wir lassen Ihr Objekt im besten Licht erstrahlen",
  expectFromUsArticle_3_Text:
    "Ihr Zimmer oder Ihre Wohnung ist Ihre Visitenkarte. Der Gast bucht bei Ihnen, aufgrund der guten und ausführlichen Beschreibung, der aussagekräftigen Bilder, einem Video, das ihn durch das Objekt führt und einer marktgerechten Preisgestaltung. Vertrauen Sie unserer Erfahrung. Wir unterstützen Sie in der Anfertigung einem perfekten Exposé Ihrer Immobilie, denn wir wissen, worauf es dabei ankommt.",
  expectFromUsArticle_4_SubHeadline: "Bleiben Sie frei",
  expectFromUsArticle_4_Text:
    "Eine Zusammenarbeit mit Urbanbnb soll und wird Ihnen Vorteile bringen. Wir sorgen für die bestmögliche Auslastung Ihres Angebotes und kümmern uns im Vorfeld um das komplette Marketing Ihrer Immobilie. Der Gast weiß, was ihn erwartet und kommt fix und fertig zum Einchecken bei Ihnen an. Sie müssen nur noch die Schlüsselübergabe übernehmen. Gut zu wissen: Bei Urbanbnb schließen Sie keinen Alleinauftrag ab. Sie können jederzeit mit anderen Agenturen weiter zusammen arbeiten. Und wenn Sie einmal andere Pläne haben mit Ihrer Immobilie, dann sperren Sie die Wohnung oder das Zimmer bei uns. So geht vermieten heute.",
  hostTeaser: `Wer private Unterkünfte erfolgreich vermieten möchte${s}
  kommt zu Urbanbnb.`,
  urbanbnbHostMeans: "Urbanbnb Gastgeber heisst:",
  urbanbnbHostMeans_Article_1_Headline: "Vertrauensvoll",
  urbanbnbHostMeans_Article_1_Text:
    "Über 70 % unserer Gastgeber sind seit unserer Firmengründung 1996 noch immer dabei. Unsere Gastgeber schätzen unsere Arbeit, die hohe Belegungsquote, aber vor allem, dass wir über die ganzen Jahre nah und erreichbar geblieben sind.",
  urbanbnbHostMeans_Article_2_Headline: "Kein Risiko",
  urbanbnbHostMeans_Article_2_Text:
    "Die Anmeldung als Gastgeber bei Urbanbnb ist völlig kostenlos. Wir berechnen nur dann eine Vermittlungsgebühr, wenn wir Ihnen auch erfolgreich einen Gast vermittelt haben.",
  urbanbnbHostMeans_Article_3_Headline: "Finden Sie den richtigen Mietpreis",
  urbanbnbHostMeans_Article_3_Text:
    "Ein hoher Mietpreis sieht auf dem Papier immer toll aus für den Gastgeber. Doch was nützt ein hoher Mietpreis, wenn es den Gästen zu teuer ist? Wir sitzen am Puls der Zeit und unterbreiten Ihnen eine marktgerechte Preisgestaltung für Ihre Wohnung. Vertrauen Sie uns – wir kennen den Markt.",
  urbanbnbHostMeans_AdditionalText: `Entscheiden Sie sich für die <span class="text-color-secondary">Alternative zur dauerhaften Vermietung</span>. Werden Sie Urbanbnb Gastgeber und freuen Sie sich schon bald auf Ihre ersten Gäste und damit verbunden mehr Geld für Ihre persönlichen Wünsche.`,

  hostLoginInfoTitle:
    "Werden Sie ein guter Gastgeber. Mit Urbanbnb an Ihrer Seite es ist ganz einfach.",
  hostLoginInfoSubtitle:
    "Für den Fall der Fälle ist es gut, wenn Sie Ihrem Gast ein paar Infos an die Hand geben:",
  hostLoginInfo: [
    {
      imgUrl: "/assets/images/gastgeber/tipps/kontaktdaten.jpg",
      title: "Kontaktdaten",
      content:
        "Erstellen Sie eine Liste mit den wichtigsten Telefonnummern für den Notfall vor wie z.B. nächstes Krankenhaus, Polizei/Feuerwehr. Ebenso ist es hilfreich dem Gast mitzuteilen, wie Sie erreichbar sind. Oder eine Ansprechperson Ihres Vertrauens. Wichtig ist, dass Ihre Gäste wissen, wen sie bei Fragen oder Problemen ansprechen können. Für Notfälle ist Ihr Gast dankbar, wenn ein erste Hilfekasten mit dem Nötigsten im Wohnraum zur Verfügung steht. Zeigen Sie Ihrem Gast wo er diesen findet.",
    },
    {
      imgUrl: "/assets/images/gastgeber/tipps/privatsphaere.jpg",
      title: "Privatsphäre",
      content:
        "Bitte nehmen Sie Rücksicht auf die Privatsphäre Ihrer Gäste. Ebenso dürfen Sie dies auch von ihm erwarten.",
    },
    {
      imgUrl: "/assets/images/gastgeber/tipps/wohnklima.jpg",
      title: "Wohnklima",
      content:
        "Bitte achten Sie darauf, dass Ihre Räumlichkeiten immer gut belüftet sind und dass die Heizung zu entsprechender Jahreszeit funktioniert. Für Ihren Gast sollte klar erkennbar sein, wo die Heizung sich befindet und wie diese zu bedienen ist.",
    },
    {
      imgUrl: "/assets/images/gastgeber/tipps/kinder.jpg",
      title: "Wenn Kinder zu Gast sind",
      content:
        "Auch Kinder sollten in Ihrer Wohnung sicher sein. Bitte achten Sie daher darauf, das zum Beispiel Kindersicherungen an den Steckdosen angebracht sind. Wenn Ihre Wohnung für Kinder nicht geeignet ist, sagen Sie das dem Gast und weisen auf besondere Gefahren hin.",
    },
    {
      imgUrl: "/assets/images/gastgeber/tipps/hausregeln.jpg",
      title: "Hausregeln",
      content:
        "Für ein harmonisches Miteinander macht es Sinn, wenn Sie Ihren Gast auf gewisse Regeln aufmerksam machen.",
    },
    {
      imgUrl: "/assets/images/gastgeber/tipps/rauchen.jpg",
      title: "Rauchen",
      content:
        "Das Rauchen in urbanbnb Unterkünften ist nicht gestattet. Stellen Sie am besten ein kleines Schild mit der Info in den Wohnraum.",
    },
    {
      imgUrl: "/assets/images/gastgeber/tipps/parken.jpg",
      title: "Parken",
      content:
        "Zeigen Sie Ihren Gästen, wo und die Parkmöglichkeiten vorhanden sind. Werden Gebühren für das Parken erhoben, bitte dem Gast mitteilen.",
    },
    {
      imgUrl: "/assets/images/gastgeber/tipps/laerm.jpg",
      title: "Lärm",
      content:
        "Bitten Sie Ihren Gast, die Lautstärke im angemessenen Rahmen zu halten. Besprechen Sie mit Ihrem Gast, ob das Mitbringen anderer Leute in Ihrer Wohnung erwünscht ist oder nicht.",
    },
    {
      imgUrl: "/assets/images/gastgeber/tipps/haustier.jpg",
      title: "Haustier",
      content:
        "Wenn Sie Haustiere gestatten, erklären Sie Ihrem Gast, wo der Liebling sein Geschäft verrichten kann (Parks, Grünanlage in Ihrer Umgebung) und ob der Gast die Hinterlassenschaften seines Hundes beseitigen muss.",
    },
    {
      imgUrl: "/assets/images/gastgeber/tipps/muelltrennung.jpg",
      title: "Mülltrennung",
      content:
        "Ihr Gast kommt aus einer anderen Stadt oder gar aus einem anderen Land. Er kann natürlich nicht wissen, wie an Ihrem Heimatort Mülltrennung geregelt wird. Erklären Sie ihm, wie das in Ihrer Stadt funktioniert. Nur so ist gewährleistet, dass er alles richtig macht.",
    },
  ],
  hospitalityTitle: "Gastfreundschaft – sieht so aus:",
  mdHospitality: `Schon beim Anlegen Ihres Wohnraums sollten Sie die Ausstattungsmerkmale so genau wie möglich beschreiben. Beschreiben Sie wie Ihre Unterkunft aussieht und was die Umgebung (Busse, Bahnen, Restaurants usw) für den Gast bereithält. Die detaillierte Beschreibung der Ausstattungsmerkmale tragen dazu bei, dass sich sehr viele Gäste für Ihr Objekt entscheiden.

  Legen Sie Ihren Preis für das Zimmer und oder Ihre Wohnung fest. Entweder vermieten Sie Tageweise und oder auch zu einem monatlichen Preis. Halten Sie fest, was Sie für Frühstück, Parkplatz, Internet oder sonstige Leistungen berechnen möchten, damit der Gast darüber im Vorfeld Bescheid weiss und es vor Ort keine Missverständnisse gibt.

  Überprüfen Sie regelmässig die Verfügbarkeit Ihres Wohnraums über den Belegungskalender auf Urbanbnb. Nur so ist gewährleistet, dass es zu keinen Überbelegungen kommt und der Gast zum gebuchten Zeitraum auch herzlich willkommen bei Ihnen ist.

  Wenn der Gast sich ankündigt: Vorab erfahren Sie alle wichtigen Details wie seine Daten, Personenanzahl, Zeitraum und dem Preis aus der Buchungsbestätigung von Urbanbnb. Diese erhalten Sie per Mail. Dann wird der Gast Sie anrufen, um seine genaue Ankunftszeit mit Ihnen persönlich abzusprechen. Selbstverständlich können Sie auch den Gast per Telefon oder Mail gleich direkt kontaktieren. Vereinbaren Sie eine Ankunftszeit, die Ihnen und dem Gast zusagt.

  Sauberkeit: Stellen Sie sicher, dass alle Räume, zum dem Ihr Gast Zutritt hat, sauber gereinigt sind. Bitte vergessen Sie dabei auch nicht, das Badzimmer/WC und die Küche besonders sauber zu halten. Die Handtücher und die Bettwäsche die Sie zur Verfügung stellen, sollten stets frisch gewaschen sein. Achten Sie auch darauf, das immer gründlich Staub gewischt ist, die Spiegel geputzt und der Mülleimer geleert ist. Schaffen Sie Platz im Schrank oder in einer Kommode, damit Ihr Gast seine eigene Kleidung verstauen kann.

  Die Anreise: Ihr Gast ist nun angekommen. Bitte nehmen Sie sich ein paar Minuten Zeit für das Check in. Die erforderlichen Check in Formulare, um die Personalien Ihres Gastes zu notieren, können Sie als Urbanbnb Gastgeber problemlos im Download Center auf unserer Internetseite runterladen. Dort finden Sie übrigens auch sehr viele weitere nützliche und wichtige Formulare zur Ihrer Verwendung. Dann übergeben Sie dem Gast seinen Hausschlüssel und kassieren Ihre Übernachtungskosten.

  Bleiben Sie Ansprechpartner für Ihren Gast während seinem Aufenthalt. Wenn dies aber mal nicht möglich ist, dann stellen Sie sicher, dass Ihr Gast eine Nummer eines Ansprechpartner bekommt (Nachbar, jemand aus der Familie usw). Selbstverständlich sind wir auch noch da. Der Gast kann sich natürlich bei Ihrer Abwesenheit mit seinen Fragen auch gerne an uns wenden.

  Die Abreise: Achten Sie darauf, dass die Abreise Ihrer Gäste ebenso problemlos verläuft wie dessen Anreise. So behält der Gast Sie in positiver Erinnerung und bucht gerne ein weiteres mal bei Ihnen. Sie erhalten die Hausschlüssel wieder und vergewissern sich, dass der Wohnraum in einem akzeptablen Zustand wieder an Sie übergeben wird.

  Veränderungen: wenn sich an Ihren Wohnraum etwas ändern sollte, kein Problem. Achten Sie aber immer darauf, dass dies in den Ausstattungsmerkmalen umgehend vermerkt ist. Nur so haben Ihre Gäste die Sicherheit, dass sie auch das erwarten können, was Sie auf der Urbanbnb Seite inseriert haben.

  Nutzen Sie die tolle Möglichkeit „von zu Hause aus“ Geld zu verdienen mit einem starken Vermittlungspartner an Ihrer Seite.`,
  mdHostFaqList: [
    {
      id: 10,
      open: true,
      title:
        "Ich bin doch bereits im Internet auffindbar. Welcher Vorteil bringt mir eine Zusammenarbeit mit Urbanbnb?",
      content:
        "Sie haben bereits eine Internetseite für Ihre Wohnung? Das ist perfekt. Doch für mehr Sichtbarkeit und damit eine bessere Auslastung Ihrer Immobilie, ist es sehr wichtig, sich im Netz breiter aufzustellen. Mit uns erreichen Sie mehr Gäste, die schnell, direkt und rechtssicher Ihr Angebot buchen werden. Unsere Gäste sind überwiegend Geschäftsreisende und Firmen, die für Ihre Mitarbeiter Unterkünfte suchen. Nutzen Sie unser Stammkundenpotential für mehr Erfolg bei der Vermietung.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/Ich-bin-doch-bereits-im-Internet-auffindbar.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/Ich-bin-doch-bereits-im-Internet-auffindbar.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 20,
      open: false,
      title: "Was unterscheidet Urbanbnb von anderen Agenturen?",
      content:
        "Sie sind bei uns richtig, wenn Sie Wert auf zuverlässigen Service legen und es Ihnen wichtig ist, einen persönlichen Ansprechpartner haben. Sie sind bei auch uns richtig, wenn Sie Ihre Immobilie lieber monatlich vermieten möchten, anstatt alle 2 Tage einen neuen Gast zu begrüßen. Unsere Gäste kommen aus beruflichen Gründen in Ihre Stadt und mieten ab 1 Monat und eben nicht Tageweise. Urbanbnb ist ein familiengeführtes Unternehmen, das seit 1996 sehr erfolgreich im Bereich Wohnen auf Zeit unterwegs ist. Unserem Service können Sie vertrauen.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/Was-unterscheidet-Urbanbnb-von-anderen-Agenturen.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/Was-unterscheidet-Urbanbnb-von-anderen-Agenturen.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 30,
      open: false,
      title: "Kann ich mit anderen Agenturen und Urbanbnb zusammenarbeiten?",
      content:
        "Ja, das ist kein Problem, wenn Sie noch mit anderen Agenturen zusammenarbeiten. Wichtig hierbei ist nur, dass Sie immer Ihren Belegungskalender sorgfältig führen, damit es nicht zu Überbelegungen kommt.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/Kann-ich-mit-anderen-Agenturen-und-Urbanbnb-zusammenarbeiten.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/Kann-ich-mit-anderen-Agenturen-und-Urbanbnb-zusammenarbeiten.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 40,
      open: false,
      title: "Wie hoch ist das Buchungsaufkommen bei Urbanbnb?",
      content:
        "Wir haben eine Auslastung in sehr vielen Städten von bis zu 90 % für das Jahr. Rufen Sie uns, um zu erfahren, wie es in Ihrer Stadt ist.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/Wie-hoch-ist-das-Buchungsaufkommen-bei-Urbanbnb.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/Wie-hoch-ist-das-Buchungsaufkommen-bei-Urbanbnb.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 50,
      open: false,
      title: "Kann der Gast vorab mein Angebot besichtigen, bevor er bucht?",
      content:
        "Nein, das geht leider nicht. Das liegt daran, dass wir eine sehr hohe Nachfrage von Gästen haben und die Objekte sehr oft bis zum Tag der Neuvermietung, noch mit einem Gast belegt sind. Wir möchten dem Gastgeber keinen Besichtigungstourismus zumuten. Denn würden wir es einem Gast gestatten zu besichtigen, müssten wir es anderen Gästen ebenfalls ermöglichen. Damit wäre der Gastgeber ständig mit dem Ausmachen von Terminen für Besichtigungen beschäftigt. Der Gast schaut sich alle Angebote mittels Bilder und Videos auf unserer Internetseite an und bucht diese dann online.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/Kann-der-Gast-vorab-mein-Angebot-besichtigen-bevor-er-bucht.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/Kann-der-Gast-vorab-mein-Angebot-besichtigen-bevor-er-bucht.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 60,
      open: false,
      title: "Wie finde ich den richtigen Preis für mein Angebot?",
      content:
        "Einen marktgerechten Preis für Ihr Angebot zu finden, ist sehr wichtig. Denn sind Sie zu günstig, buchen vielleicht nicht die gewünschten Gäste bei Ihnen. Sind Sie zu teuer, dann buchen zu wenig Gäste bei Ihnen. Wir unterstützen Sie in der richtigen Preisfindung und unterbreiten Ihnen eine marktgerechte Preisgestaltung. Senden Sie einfach Bilder Ihrer Wohnung oder Zimmer und wir stellen Ihnen kostenfrei eine Preisgestaltung zusammen.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/Wie-finde-ich-den-richtigen-Preis-fuer-mein-Angebot.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/Wie-finde-ich-den-richtigen-Preis-fuer-mein-Angebot.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 70,
      open: false,
      title: "Wie funktioniert der Ablauf der Buchungen genau?",
      content:
        "Zuerst wird Ihre Unterkunft auf unserer Internetseite bestens platziert und auf optimale Sichtbarkeit geachtet. Unsere Arbeit besteht darin, das komplette Marketing für Ihre Immobilie zu übernehmen. Sie bekommen von uns den „fertigen“ Gast. Dieser ist bestens informiert, was ihn vor Ort erwartet und was er zu tun hat, damit die Schlüsselübergabe und die Bezahlung der Miete reibungslos über die Bühne geht. Der Gast erhält alle Informationen wie, Verfügbarkeit, Ausstattungsmerkmale, Umgebung, Preise und kann Ihre Unterkunft, wenn verfügbar, sofort online buchen. Sobald eine Buchung getätigt wurde, erhalten Sie eine Buchungsbestätigung per E-Mail plus auf Ihr Handy eine Kurzinfo per SMS. Ihre Unterkunft wird dann automatisch im Belegungskalender für den Zeitraum gesperrt.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/Wie-funktioniert-der-Ablauf-der-Buchungen-genau.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/Wie-funktioniert-der-Ablauf-der-Buchungen-genau.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 80,
      open: false,
      title: "Kann ich den Mindestaufenthalt meiner Gäste selbst bestimmen?",
      content:
        "Es ist jederzeit möglich, den Mindestaufenthalt selbst anzupassen. Wir empfehlen eine Mindestbuchungsdauer von mindestens 8 Nächten. Damit ist gewährleistet, dass sich Ihr Aufwand mit Check-in und out überschaubar hält. Besser allerdings ist es, Ihr Angebot ab 1 Monat zu Verfügung zu stellen.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/Kann-ich-den-Mindestaufenthalt-meiner-Gaeste-selbst-bestimmen.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/Kann-ich-den-Mindestaufenthalt-meiner-Gaeste-selbst-bestimmen.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 90,
      open: false,
      title:
        "Gibt es eine Mindestlaufzeit oder eine Kündigungsfrist als Gastgeber?",
      content:
        "Nein. Es gibt weder eine Mindestlaufzeit noch eine Kündigungsfrist. Wenn Sie Ihre Immobilie wieder selbst benötigen, dann sperren Sie Ihr Angebot im Belegungsplan. Sie loggen sich einfach auf Ihrem Gastgeberaccount ein und sperren den gewünschten Zeitraum.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/Gibt-es-eine-Mindestlaufzeit-oder-eine-Kuendigungsfrist-als-Gastgeber.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/Gibt-es-eine-Mindestlaufzeit-oder-eine-Kuendigungsfrist-als-Gastgeber.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 100,
      open: false,
      title:
        "Der persönliche Kontakt zu meinen Gästen ist mir wichtig, fällt dieser dann komplett weg als Urbanbnb Gastgeber?",
      content:
        "Nein, natürlich haben Sie weiterhin die Möglichkeit nach der Buchung mit Ihren Gästen in Kontakt zu treten. Dazu erhalten Sie alle Kontaktdaten des Gastes.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/Der-persoenliche-Kontakt-zu-meinen-Gaesten-ist-mir-wichtig.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/Der-persoenliche-Kontakt-zu-meinen-Gaesten-ist-mir-wichtig.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 110,
      open: false,
      title:
        "Wie werde ich benachrichtigt, wenn meine Unterkunft von einem Gast gebucht wurde?",
      content:
        "Sobald ein Gast Ihr Angebot gebucht hat, erhalten Sie umgehend eine Buchungsbestätigung. Diese Bestätigung wird per E-Mail an Sie versendet und zusätzlich erhalten Sie eine Kurzinfo per SMS. Gleichzeitig erhält der Gast eine Bestätigung mit Ihren Kontaktdaten. Unser System sperrt dann automatisch Ihr Angebot für diesen gebuchten Zeitraum, sodass es zu keiner Überbelegung kommen kann. Sie müssen sich also nicht darum kümmern.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/Wie-werde-ich-benachrichtigt.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/Wie-werde-ich-benachrichtigt.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 120,
      open: false,
      title: "Kann ich meine Unterkunft weiterhin auch selbst belegen?",
      content:
        "Ja, Sie können Sie Ihr Objekt auch selbst vermieten. Dazu ist es wichtig, dass Sie die Verfügbarkeiten Ihrer Immobilie über Ihren Belegungskalender bei uns im Login Bereich immer aktualisieren. Wenn Sie Ihr Angebot auf unserer Seite sperren, wird auch keine Buchung erfolgen. Ist Ihr Angebot frei geschaltet, ist es jederzeit buchbar für unsere Gäste.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/Kann-ich-meine-Unterkunft-weiterhin-auch-selbst-belegen.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/Kann-ich-meine-Unterkunft-weiterhin-auch-selbst-belegen.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 130,
      open: false,
      title: "Wie erfolgt die Bezahlung der Miete an mich?",
      content:
        "Wir haben den Gast bestmöglich vorbereitet und dieser ist informiert, dass er bei Anreise in bar die erste Miete und die Kaution bei Ihnen vor Ort bezahlt. Wenn eine Firma gebucht hat, dann wird diese die Übernachtungskosten meist überweisen wollen. Dies geschieht per Vorabüberweisung auf Ihr Konto.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/Wie-erfolgt-die-Bezahlung-der-Miete-an-mich.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/Wie-erfolgt-die-Bezahlung-der-Miete-an-mich.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 140,
      open: false,
      title: "Welche Kosten entstehen für mich?",
      content:
        "Das Einstellen Ihres Angebots auf unserer Seite ist völlig kostenfrei. Bei Vermittlung von Gästen, die Ihr Angebot gebucht haben, berechnen wir nur 10% netto Vermittlungsprovision (plus Mwst.). Und das auch nur bei erfolgreicher Vermittlung und nur vom reinen Übernachtungspreis. Nicht von den Zusatzeinnahmen wie ggf. Internet, Reinigung, Parkplatz usw., die Sie zusätzlich zum Mietpreis berechnen können. Die Teilung ist also, dass Ihnen 90 % der Einnahmen bleibt und 10 % erhalten für unsere Arbeit und Marketing.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/Welche-Kosten-entstehen-fuer-mich.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/Welche-Kosten-entstehen-fuer-mich.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 150,
      open: false,
      title: "Wie funktioniert die Abrechnung für Urbanbnb?",
      content:
        "Nach erfolgreicher Gästevermittlung Sie erhalten zum Ende des Monats per Mail eine Übersicht über alle Buchungen, die gelaufen sind. Selbstverständlich ersehen Sie die monatlichen Abrechnungen, sowie laufende und zurückliegende Buchungen in Ihrem Gastgeberaccount. Unser Honorar buchen wir dann per Lastschriftverfahren von Ihrem Konto ab.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/Wie-funktioniert-die-Abrechnung-fuer-Urbanbnb.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/Wie-funktioniert-die-Abrechnung-fuer-Urbanbnb.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 160,
      open: false,
      title: "Was mache ich bei einer Überbelegung?",
      content:
        "Achten Sie einfach darauf, Ihren Belegungskalender immer aktuell zu halten. So können Sie problemlos Überbuchungen vermeiden und es kann zu keiner Doppelbelegung kommen. Sollte es doch einmal vorkommen, weil Sie vielleicht vergessen haben zu sperren, dann ist es wichtig, immer umgehend zu reagieren. Informieren Sie uns rechtzeitig über die Doppelbelegung, damit wir uns um den Gast kümmern und ihm eine Umbuchung anbieten zu können. Gemeinsam finden wir sicher eine Lösung.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/Was-mache-ich-bei-einer-Ueberbelegung.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/Was-mache-ich-bei-einer-Ueberbelegung.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 170,
      open: false,
      title: "Was passiert, wenn ein Gast storniert?",
      content:
        "Pläne können sich ändern. Sollte ein Gast stornieren wollen, muss er das immer uns - Urbanbnb mitteilen. Wenn der Gast Sie direkt über das Storno informiert, teilen Sie uns das bitte mit. Wir können dann Ihre Unterkunft umgehend für neue Anfragen auf unserer Internetseite frei schalten. Selbstverständlich haben Sie die Möglichkeit im Rahmen der Stornobedingungen Ihren Schaden dem Gast zu berechnen.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/Was-passiert-wenn-ein-Gast-storniert.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/Was-passiert-wenn-ein-Gast-storniert.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 180,
      open: false,
      title:
        "Wenn ich mich für die Zusammenarbeit mit Urbanbnb entscheide, wie sehen dann die nächsten Schritte aus?",
      content:
        "Um Gastgeber zu werden, melden Sie Ihre Immobilie einfach über die Gastgeberregistrierung auf unserer Internetseite: https://www.urbanbnb.de/gastgeberlogin?lang=de an. Schreiben Sie etwas zu Ihrem Angebot wie Lage, Ausstattung und Beschreibung der Unterkunft und laden Ihre Bilder hoch. Tragen Sie dann noch Ihre freien Zeiträume ein und schon kann es losgehen. Wenn Sie einmal Änderungen im Text, Bilder austauschen oder Sperren eintragen möchten, können Sie das jederzeit selbständig vornehmen. Sobald Ihre Anmeldung abgeschlossen ist und Sie Ihr Angebot online schalten, können Sie sofort als Gastgeber bei Urbanbnb online gebucht werden. Wenn Sie beim Anlegen Hilfe oder Tipps benötigen, dann schreiben Sie uns eine Mail oder kontaktieren uns über WhatsApp.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/Wenn-ich-mich-fuer-die-Zusammenarbeit-mit-Urbanbnb-entscheide.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/Wenn-ich-mich-fuer-die-Zusammenarbeit-mit-Urbanbnb-entscheide.mp3",
          type: "audio/mpeg",
        },
      ],
    },
  ],
  mdHostFaq: "",

  // hostmessage
  hostMessageTitle: "Ihre Meinungen und Fragen sind uns wichtig.",
  yourMessage: "Ihre Nachricht",
  sendMessage: "Nachricht absenden",

  // pwreminder
  pwReminder: "Passworterinnerung",
  pwReminderMsg: "Passwort vergessen?",
  pwReminderModalMsg:
    "Falls unter der angegebenen E-Mail ein Nutzerkonto existiert wird ihnen eine Passworterinnerung per Mail zugesendet.",

  // create offer
  createOffer: "Angebot erstellen",
  offerMsg: "Zum Erstellen eines Angebots bitte einen Zeitraum auswählen.",
  offerSuccessMsg: "Ihr Angebot wurde erfolgreich versendet.",
  sendMail: "E-Mail versenden",

  // favoriteDropdown
  favorites: "Merkliste",
  share: "Teilen",
  manageFavorites: "Merkliste verwalten",
  deleteAll: "Alle entfernen",
  noFavorites1: "Keine Unterkünfte ausgewählt. Zum Merken von Unterkünften",
  noFavorites2: "anklicken.",

  // Details
  roomType: "Art der Zimmer",
  roomtypeFor: "Unterkunft für bis zu",
  roomtypeForTooltip:
    "Wenn Sie das Objekt als Einzelperson buchen, erhalten Sie natürlich das Objekt zur alleinigen Nutzung, unabhängig ob noch mehr Betten vorhanden sind.",
  roomSize: "Größe der Unterkunft",
  objectLocation: "Lage des Objektes",
  roomtypeHeading: "Beschreibung der Unterkunft",
  photos: "Bilder",
  panoramaHeading: "360° - Ansichten",
  panoramaMsg:
    "Sie können sich im folgenden Bild 360° drehen. Klicken Sie dazu auf das Bild und bewegen die Maus mit gedrückter Maustaste. Mit den vor/zurück Pfeilen im Bild gelangen Sie zur nächsten Position bzw. Ansicht im Zimmer oder der Wohnung.",
  ratings: "Bewertungen",
  resetTimespan: "Zeitraum zurücksetzen",
  backToResults: "Zurück zu den Ergebnissen",
  favoriteRoomtype: "Objekt merken",
  isFavorite: "gemerkt",
  moreInfos: "Mehr Infos",
  stillUnsecure: "Noch unsicher? <br/> Unsere Lösung: Ein Probemonat",
  toAccommodation: "Zur Unterkunft",
  toProvideMoreSecurity:
    "Um Ihnen jedoch mehr Sicherheit zu bieten, haben wir ein besonderes Angebot entwickelt: <em>Buchen Sie die Wohnung zunächst für einen Monat </em> und testen Sie sie vor Ort. Sehen Sie dies als eine Art <em>„Probemonat“</em>, in dem Sie die Unterkunft unverbindlich kennenlernen können. Wenn Sie danach zufrieden sind, steht einer Verlängerung Ihres Aufenthalts nichts im Wege. So können Sie sich ohne langfristige Verpflichtung ein genaues Bild von der Wohnung machen. Vertrauen Sie auf unsere langjährige Erfahrung, die Sicherheit geprüfter Objekte und unser persönliches Engagement – Urbanbnb ist Ihr zuverlässiger Partner für möbliertes Wohnen auf Zeit.",
  bookATestingmonth: "Buchen Sie einen Probemonat",
  payment: "Bezahlung",
  paymentTooltip:
    "Zahlbar sind die Kosten bei Anreise in bar oder vorab als Banküberweisung an den Gastgeber. Bei Buchung von 2 Monaten oder mehr: Bei Anreise 1. Monat und Kaution zahlbar an Gastgeber, Folgemonat dann jeweils am Stichtag Anreise Folgemonat.",
  blockingAdGuestTooltip:
    "Im Zeitraum einer An- und Abreisesperre kann keine An- und Abreise erfolgen. Der Zeitraum kann aber überbucht werden.",
  openRoutePlanning: "in größerer Kartenansicht (Routenplaner) öffnen",
  youtubeCookieNotAcceptedModalTitle: "Youtube Cookie nicht akzeptiert",
  youtubeCookieNotAcceptedModalText:
    "Youtube Videos können nicht angezeigt werden, da Cookies nicht akzeptiert wurden. Bitte öffnen Sie die Cookie Einstellungen und akzeptieren Sie den 'Youtube' Cookie.",
  youtubeCookieNotAcceptedModalButtonText: "Cookie Einstellungen öffnen",

  // persons
  guests: ["Gast", "Gäste"],
  adults: ["Erwachsener", "Erwachsene"],
  children: ["Kind", "Kinder"],
  persons: ["Person", "Personen"],
  titles: ["Herr", "Frau", "keine Angabe"],

  //extensionOption
  extensionOption: "Verlängerungsoption",
  extensionOptionCredit: "Rückerstattung Verlängerungsoption",
  extensionOptionTooltip:
    "Wenn Sie eine Buchung von mehr als 1 Monat tätigen, dann ist evtl. davon auszugehen, dass Sie die Unterkunft nach Ihrem Buchungszeitraum noch länger mieten wollen. Für diesen Fall bieten wir die Verlängerungsoption an, die Ihnen garantiert, dass das reservierte Objekt im Anschlußzeitraum für Sie geblockt ist und von keinem anderen Gast während der Option gebucht werden kann. Dieser Service ist erstmal kostenpflichtig - die Kosten werden aber mit einer Anschlussbuchung verrechnet. Sollten Sie also eine Anschlußbuchung in der gleichen Unterkunft tätigen, fallen insgesamt keine Mehrkosten an.",

  // prices
  price: "Preis",
  prices: "Preise",
  roomPrice: "Übernachtung",
  cleaning: "Reinigung",
  cleaningIntermediate: "Zwischenreinigung",
  cleaningIntermediateTooltip:
    "Die Gebühr für die Zwischenreinigung fällt an, wenn Ihr Gastgeber die Unterkunft entweder 14-tägig oder bei Daueraufenthalten mindestens einmal im Monat zwischenreinigt.",
  onlineVisitTitle:
    "Onlinebesichtigung verfügbar – Jetzt Video ansehen & Objekt live erleben!",
  onlineVisit: "Onlinebesichtigung",
  onlineVisitDescription:
    "Was bedeutet „Onlinebesichtigung“? Wir bieten keine Vor-Ort-Besichtigungen an – aber mit unserem Video erhalten Sie trotzdem einen realistischen Eindruck! Der Rundgang zeigt Ihnen alle Räume, Ausstattung und Atmosphäre so transparent wie möglich – bequem von Zuhause aus. Ideal für Gäste, die von weiter weg anreisen oder sich schnell entscheiden möchten. Einfach Video starten – und direkt erleben, was Sie erwartet.",

  cleaningFinal: "Endreinigung",
  cleaningFinalTooltip:
    "Die Endreinigung, die i.d.R. am Ende des Aufenthaltes noch umfänglicher durchgeführt wird, wird unabhängig einer Zwischenreinigung erhoben. Diese Gebühr fällt nur an, wenn Sie mehr als 20 Nächte buchen. Kürzere Tagesbuchungen zahlen keine Endreinigung.",
  onlineDiscount: "Online-Rabatt 5%",
  total: "Gesamt",
  totalPrice: "Gesamtkosten",
  depositOnArrival: "Kaution bei Anreise",
  depositInfo: "Kautionshinweise",
  deposit: "Kaution",
  depositAmount1: "Die Kaution beträgt",
  depositAmount2: "vom Übernachtungspreis",
  perDay: "pro Nacht",
  perMonth: "pro Monat",
  perPerson: "pro Person",
  overnight: ["Übernachtung", "Übernachtungen"],
  shortTimeBooking: "Kurzzeitbuchung",
  shortTimeBookingTooltip:
    "Wenn Ihr gewählter Buchungszeitraum die Mindestbuchungsdauer des Objektes unterschreitet, dann fällt ein einmaliger Aufschlag auf die Buchung an.",
  bookObject: "Objekt Buchen",
  bookingValidationFailed: "Buchung nicht möglich",

  // price info
  trafficConnection: "Verkehrsanbindung",
  tipsForArea: "Tipps für die Umgebung",
  mdDetailsPriceHints: `
#### Bitte beachten Sie:

Die aufgeführten Kosten in der Buchungsbestätigung wie die Übernachtungskosten, Kaution, Reinigungsgebühren, sowie eventuelle Kosten für die Verlängerungsoption sind vor Anreise an den Gastgeber zu überweisen. Bitte sprechen Sie vor Ihrer Anreise die Zahlung mit dem Gastgeber ab bzw. erfragen Sie dessen Bankverbindung. Die Überweisung der ausgewiesenen Kosten in der Buchungsbestätigung muss zwingend 1 Tag vor Anreise auf dem Konto des Gastgebers eingegangen sein. Falls eine Überweisung der Kosten aus Zeitgründen, weil durch kurzfristiger Buchung nicht mehr machbar ist, bezahlen Sie bitte vor Ort bei Anreise den Betrag in bar an Ihren Gastgeber.


#### Anzahlung auf die Buchungsbestätigung:

Sollte Ihre Buchung bzw. Anreise mehr als 14 Tage vor Anreise getätigt worden sein, behält sich der Gastgeber vor, eine Anzahlung in Höhe von 30 % aus der Miethöhe als Anzahlung auf die Buchung zu berechnen. Dies gilt auch für Buchungen von Gästen, deren Wohnsitz sich im Ausland befindet. Bei Rückfragen auch in Sache Bankverbindung kontaktieren Sie Ihren Gastgeber. Die Kontaktdaten ersehen Sie in der Buchungsbestätigung.


#### Zahlung der Übernachtungskosten:

Bei Buchung von 2 Monaten oder mehr ist die Zahlung der Übernachtungskosten immer monatlich.


#### Info zur Reinigung:

Manche Gastgeber berechnen eine Zwischenreinigung ( 14 tägige Grundreinigung).
Andere Gastgeber berechnen nur eine Endreinigung, dann ist die Reinigung während des Aufenthalts Sache des Gastes.


#### Bettwäsche und Handtücher:

Dies ist eine Erstausstattung die beinhaltet das Bettzeug, wie auch Kissen und Laken, Handtücher sind in der Regel selbst mitzubringen.
`,
  mdRelocationMsg:
    "Alle unsere möblierten Wohnungen sind anmeldefähig – das heißt: Sie können Ihren Wohnsitz offiziell registrieren und erhalten nach der Buchung vom Gastgeber eine Wohnungsgeberbestätigung. Diese benötigen Sie z.B. für das Bürgeramt oder bei der Beantragung Ihres Visums.<br><br>Mehr Informationen rund um Visum, Anmeldung & Relocation in Deutschland finden Sie hier: [Relocation & Visum – So funktioniert’s](/page/de/relocation).",

  // related roomtypes
  relatedRoomtypes: "Andere Unterkünfte im gleichen Objekt",

  // AddressSearch
  chooseAddress:
    "Bitte die Adresse eingeben und den am besten passenden Google-Vorschlag übernehmen.",

  // address
  address: "Adresse",
  addressNumber: "Objektnummer",
  addressType: "Objektart",
  targetAddress: "Zieladresse (optional, wenn bekannt)",

  // filter
  roomtype: "Art der Unterkunft",
  room: "Zimmer",
  flat: "Wohnung",

  // sorting
  sortBy: "Sortieren nach",
  distance: "Entfernung",

  // comments
  rating: "Bewertung",
  noRatings: "Nicht genügend Bewertungen vorhanden",
  noComments: "Keine Kommentare vorhanden",
  averageRating: "Gesamtbewertung",
  cleanlinessRating: "Sauberkeit",
  friendlinessRating: "Freundlichkeit",
  receptionRating: `Empfang${nbsp}/ Begrüßung`,
  featureRating: "Ausstattung",
  readComments: "Gästebewertungen lesen",
  cleaningPrice: "Reinigungsgebühr",
  dynamicCleaningPrice: "Zwischenreinigungsgebühr",
  staticCleaningPrice: "Endeinigungsgebühr",
  depositMsg:
    "Ihr Gastgeber wird Ihnen bei Anreise eine Sicherheits- und Schlüsselkaution in Höhe von 30% vom Übernachtungspreis berechnen. Diese Kaution wird in bar bei Anreise gegen Quittung an den Gastgeber bezahlt. Die Kaution erhalten Sie nach ordnungsgemäßer Rückgabe der Schlüssel und Mietobjekt zurück. Bitte beachten Sie daher, das nur Schlüsselrückgabe rechtlich die Räumung des Objektes bedeutet, andernfalls wird das Objekt weiter berechnet ggf. die Kosten für Schlüsselersatz Ihnen berechnet werden können. Deshalb am Abreisetag einfach den Schlüssel zurückgeben :-).",
  commentMsg:
    'Warum Sie unseren Bewertungen vertrauen können: Nur Gäste, die über urbanbnb gebucht und in der Unterkunft übernachtet haben, können eine Bewertung abgeben. So kommen unsere Bewertungen immer von "echten" Gästen wie Ihnen.',

  // booking steps
  loginStep: "Anmeldung / Registrierung",
  smsStep: "SMS - Authentifizierung",
  book: "Buchen",
  bookArticleText:
    "Finden Sie die perfekte Unterkunft, zugeschnitten auf Ihre Wünsche und Vorstellungen. Egal, ob kleines Gästezimmer oder eine großzügig ausgestattete Wohnung.",
  bookingLoginMsg:
    'Wenn Sie schon einmal bei uns gebucht haben, geben Sie bitte Ihre hinterlegte E-Mail Adresse und das Passwort ein. Sollten Sie Ihr Passwort vergessen haben, senden wir es Ihnen über die "Passwort vergessen" Funktion an Ihre im System hinterlegte E-Mail Adresse zu. Schauen Sie ggf. in Ihrem Spam- oder Junkordner nach.',

  // booking header
  bookingPriceHint:
    "(Zu zahlen bei Anreise an den Gastgeber in bar oder gegebenenfalls als Vorabüberweisung. Die Kaution beträgt 30% vom Übernachtungspreis.)",

  // user details
  name: "Name",
  username: "Benutzername / E-Mail",
  firstname: "Vorname",
  lastname: "Name",
  title: "Anrede",
  company: "Firma",
  street: "Strasse",
  houseNr: "Hausnummer",
  postcode: "Postleitzahl",
  city: "Ort",
  town: "Stadt",
  country: "Land",
  email: "E-Mail",
  email2: "Weitere E-Mail",
  email2Tooltip:
    "Falls Sie die Buchungsbestätigung an eine andere, alternative E-Mail Adresse auch haben wollen, dann bitte diese hier zusätzlich eintragen.",
  oldPassword: "Bisheriges Passwort",
  password: "Passwort",
  newPassword: "Neues Passwort",
  passwordConfirm: "Passwort bestätigen",
  mobile: "Telefonnummer (bevorzugt Mobil)", //"Mobilnummer",
  mobileNumber: "Mobilnummer",
  phone: "Weitere Telefonnummer", //"Telefonnummer",
  phonenumber: "Telefonnummer",
  mobileSMS: "SMS-Telefonnummer",
  newsletter: "Newsletter",
  allowNewsletter:
    "Ich möchte gelegentlich Informationen per E-Mail über das Portal erhalten.",
  fax: "Fax",

  // userchange
  mdUserChangeMsg:
    "Hinweis:  \nWenn Sie Benutzerdaten ändern, müssen Sie dies durch die Eingabe des Passwortes bestätigen!",

  // register
  registerNow: "Jetzt unverbindlich registrieren",
  guestRegister: "Gastregistrierung",
  hostRegister: "Gastgeber-Registrierung",
  guestRegisterInfo:
    "Geben Sie bitte Ihre Kontaktdaten für die Gastregistrierung ein.",
  hostPhoneRequired:
    "Die Telefonnummer (bevorzugt Mobil) wird für die Buchungsbestätigung benötigt. Sie wird nur bei einer Buchung an den Gast weitergegeben, damit dieser dann seine Anreise mit Ihnen abstimmen kann. Die Telefonnummer erscheint daher nirgends im Internet oder gegenüber Dritten.",
  mdAcceptHostTerms: `Ich akzeptiere die [AGB´s](/assets/pdf/Gastgeber_AGBs.pdf) für Gastgeber, die [Widerrufsbelehrung](/assets/pdf/Gastgeber_Widerrufsrecht.pdf) und die [Datenschutzerklärung](/assets/pdf/Datenschutzerklaerung.pdf).`,
  yourAdvantages: `### Ihre Vorteile bei urbanbnb

  - Flexibler als Dauervermietung
  - Höhere Einnahmen
  - Keine Mietrechtstreitigkeiten
  - Gastgeber statt Vermieter
  - Sie legen die Mindestbuchungsdauer selbst fest
  - Sie legen die Preise selbst fest

Und das Beste – der Objekteintrag ist völlig kostenlos. Wir berechnen nur 10% netto Servicegebühr bei einer erfolgreichen Gästebuchung vom reinen Übernachtungspreis. Also ohne Zusatzeinnahmen wie Internet, Reinigung, Waschmaschine, Parkplatz etc.

**Legen Sie Ihr Objekt an und schalten es online frei und los geht\`s mit den Gästebuchungen.**`,

  // Cancellation
  cancellationMsg:
    "Hinweis auf Stornoversicherung: Sichern Sie sich ab! Nach Abschluss der Buchung können Sie eine Stornoversicherung abschließen.",
  cancellationMsg2:
    "Hinweis auf Stornoversicherung: Weil sich Pläne ändern können: sichern Sie Ihre Buchung mit einer Stornoversicherung ab. Scrollen Sie im Text nach unten, für mehr Information und wenn Sie eine Stornoversicherung abschliessen möchten.",

  // smsAuth
  smsAuthMsg:
    "Bitte geben Sie jetzt eine Mobilnummer ein um den SMS-Authentifizierungscode anzufordern. Dieser Code erscheint dann per SMS auf die angegebene Mobilnummer. Diesen Code bitte dann im nächsten Schritt eintragen, um mit der Buchung fortzufahren.",
  checkData:
    "Prüfen Sie Ihre Kontaktdaten und fordern Sie den SMS-Authentifizierungscode an",
  changeUserInfo: "Benutzerdaten ändern",
  saveChanges: "Änderungen speichern",
  mobileForAuth: "Mobiltelefon zur SMS-Authentifizierung",
  onlyAuth:
    "nur zur Bestätigung, wird nicht gespeichert, muss nicht die Mobilnummer des Gastes sein",
  authcodeHint:
    "Bitte geben sie nun den vierstelligen SMS-Authentifizierungscode ein, den sie soeben auf ihr Handy zugesendet bekommen haben.",
  confirmationCode: "SMS-Authentifizierungscode",
  getAuthCode: "SMS-Authentifizierungscode anfordern",
  submitAuthCode: "SMS-Authentifizierungscode absenden",
  useNewNumberMsg:
    "Haben Sie noch keinen SMS-Authentifizierungscode auf Ihre Mobilnummer erhalten? Warten Sie bitte ca. 2-3 Minuten. Je nach Mobilanbieter kann es etwas dauern, bis der Code gesendet wird. Falls Sie sich bei Eingabe der Mobilnummer vertippt haben können Sie ebenfalls einen neuen Code anfordern.",
  useNewNumber: "SMS-Authentifizierungscode erneut anfordern",
  smsUnreachableMsg:
    "Die SMS-Schnittstelle ist leider zurzeit nicht erreichbar. Bitte geben sie stattdessen folgenden Code ein:",

  // booking
  finishBooking: "Buchung abschließen",
  bookNow: "Jetzt Zahlungspflichtig buchen",
  subscribe:
    "Ich möchte gelegentliche Informationen über neue Funktionen des Portals erhalten.",
  wantsToRate: "Ich möchte das Objekt nach meinem Besuch bewerten",
  readAGB:
    "Ich habe die [AGBs](/page/de/agbs) gelesen, verstanden und akzeptiert.",
  readPrivacyPolicy:
    "Ich habe die [Datenschutzerklärung](/page/de/datenschutz) zur Kenntnis genommen.",
  bookingErrorMsg:
    "Sehr geehrter Gast, die Buchung dieses Objektes im ausgewählten Zeitraum ist zwischenzeitlich nicht mehr möglich, weil parallel zu Ihnen ein anderer Gast eine Buchung vorgenommen hat. Bitte wählen Sie ein anderes Objekt oder einen anderen Buchungszeitraum. Vielen Dank.",

  // booking confirm
  remarks: "Anmerkungen",
  remarkTooltip:
    "Hier bitte auch angeben, ob Sie z.B. Haustiere bei sich haben, dabei würden zusätzliche Kosten anfallen, bitte lesen Sie dazu auch die AGBs.",
  acceptCancellationPolicy: "Verzicht auf Widerrufsfrist",
  acceptCancellationPolicyTooltip:
    "Ich verlange und bin ausdrücklich damit einverstanden, dass Sie bereits vor dem Ende der Widerrufsfrist mit der Ausführung der Dienstleistung, die Gegenstand des zu schließenden Vertrags ist, beginnen. Ferner ist mir bekannt, dass ich bereits mit vollständiger Vertragserfüllung durch Sie das mir gesetzlich zustehende Widerrufsrecht verliere.",

  // bookingInfo
  bookingConfirmation: "Buchungsbestätigung",
  showBookingConfirmation: "Buchungsbestätigung anzeigen",
  mdBookingConfirmationMsg: `Herzlichen Glückwunsch!  

Ihre Buchung ist erfolgreich und verbindlich bei uns eingegangen. Der Gastgeber freut sich sehr darauf, Sie schon bald begrüßen zu dürfen. Alle relevanten Informationen zur Unterkunft, den Kosten sowie den Reisedetails finden Sie auch noch einmal übersichtlich in Ihrer **Buchungsbestätigung per E-Mail**.  
  
Bitte beachten Sie, dass mit Abschluss der Buchung unsere **Allgemeinen Geschäftsbedingungen (AGB)** akzeptiert wurden. Besonders hinweisen möchten wir Sie auf die geltenden **Stornoregelungen**, die Sie jederzeit hier nachlesen können:  
(https://www.urbanbnb.de/page/de/agbs?lang=de#agbs_08)[https://www.urbanbnb.de/page/de/agbs?lang=de#agbs_08]
  `,

  summary: "Zusammenfassung",
  addressDetails: "Objektdaten",
  hostDetails: "Gastgeberdaten",
  bookingDetails: "Buchungsdetails",
  requiredFeature: "(Pflichtfeld)",
  paidFeatures: "Kostenpflichtige Ausstattungsmerkmale",
  paidFeature: "Kostenpflichtiges Ausstattungsmerkmal",
  mdPaymentInfo: `#### KAUTION:
  Ihr Gastgeber wir Ihnen bei Anreise eine Sicherheits- und Schlüsselkaution in Höhe von 30% vom Übernachtungspreis berechnen. Diese Kaution wird in bar bei Anreise gegen Quittung an den Gastgeber bezahlt. Die Kaution erhalten Sie nach ordnungsgemässer Rückgabe der Schlüssel und Mietobjekt zurück. Bitte beachten Sie daher, das nur die Schlüsselrückgabe rechtlich die Räumung des Objektes bedeutet. Andernfalls werden die Übernachtungskosten bis zur vollständigen Schlüsselrückgabe weiter berechnet ggf. können Ihnen die Kosten für einen Schlüsselersatz in Rechnung gestellt werden. Deshalb am Abreisetag einfach den Schlüssel zurückgeben :-).

  #### ZAHLUNG:
  Den Betrag zahlen Sie bitte bei Anreise an den oben genannten Gastgeber in Bar oder per Vorabüberweisung, wenn der Gastgeber dies ermöglicht. Die Gesamtkosten sind die Übernachtungskosten für den gesamten Zeitraum und alle Personen inkl. Reinigungsgebühr. Bei Buchung von 2 Monaten oder mehr: Bei Anreise 1. Monat und Kaution zahlbar an Gastgeber, Folgemonat dann jeweils am Stichtag Anreise Folgemonat. Bei Buchungen aus dem Ausland kann der Gastgeber eine Anzahlung in Höhe von 30% des Gesamtpreises vorab berechnen.

  Vor dem Einzug und nach dem Auszug findet eine Objektüberprüfung mit Ihnen durch den Gastgeber statt. Es wird sauber übergeben und soll im selben Zustand übergeben werden. Bei nicht ordnungsgemäßer Rückgabe der Mietsache behält sich der Gastgeber vor, verursachte Schäden oder ein übermäßig verschmutztes Mietobjekt in Rechnung zu stellen bzw. mit der bei Anreise fälligen Kaution zu verrechnen. Bitte klären Sie dies mit Ihrem Gastgeber direkt ab.

  Wichtig: Bitte sprechen Sie telefonisch vor Anreise mit dem o.g. Gastgeber Ihre voraussichtliche Ankunftszeit ab. Es wird keine Gewähr für die rechtzeitige Übergabe des Objektes übernommen, daher unbedingt direkt mit dem Gastgeber abklären.

  Wir wünschen Ihnen schon jetzt eine gute Anreise und angenehmen Aufenthalt.

  Bei Rückfragen oder weitere Informationen stehen wir Ihnen per WhatsApp unter der Telefonnummer <a href="https://wa.me/4915202105848" target="_blank">+49 1520 210 5848</a> gerne zur Verfügung.

  Viele Grüße sendet Ihnen das Team von urbanbnb`,
  insuranceComment:
    "Sie haben nachfolgend die Möglichkeit optional eine Reiserücktrittversicherung abzuschließen. Dies ist ein Angebot der ERV Europäische Reiseversicherung AG. Die Bestellung, Bezahlung und Abwicklung der Reiserücktrittversicherung erfolgt ausschließlich und direkt mit der ERV AG und über deren Bezahlsysteme. Urbanbnb stellt dafür nur die Weboberfläche zur Verfügung. Wir sehen dies als Serviceinformation, damit Sie im Rahmen Ihrer Reise daran gedacht haben.",
  travelCancellationInsurance: "Reiseschutz",
  mdInsuranceMsg: `Für einen unbeschwerten und sicheren Aufenthalt empfehlen wir Ihnen den Reiseschutz der ERV. Er bewahrt Sie im Krankheitsfall und weiteren möglichen Risiken vor Rücktritts- und Abbruchkosten.`,

  // guest
  bookingOverview: "Buchungsübersicht",
  currentBookings: "Aktuell gebuchte Unterkünfte",
  expiredBookings: "Vergangene Buchungen",
  bookAgain: "Unterkunft erneut buchen",

  // hostChange
  yourAccount: "Ihr Account",
  toYourAccount: "Zu Ihrem Account",
  addressOverview: "Objektübersicht",
  mdAddressOverviewTextInfo: `### Objektübersicht (verschiedene Gebäude/Häuser)

  Hier legen Sie zuerst Ihr Gebäude an, in welchem sich das oder die Zimmer bzw. Wohnungen befinden. In einem späteren Schritt legen Sie die einzelnen Unterkünfte (Zimmer/Wohnungen) an. Haben Sie mehrere Gebäude, dann diese bitte jeweils als einzelne Objekte anlegen.`,
  quarters: "Unterkünfte",
  beds: "Betten",
  messageCenter: "Mitteilungs-Center",
  contactData: "Kontaktdaten",
  bankDetails: "Bankverbindung",
  manager: "Betreuer Name",
  managerContact: "Betreuer Kontaktdaten",
  managerEmail: "Betreuer E-Mail",
  managerTitle: "Betreuung der Objekte",
  mdManagerMsg:
    "Wenn Sie für Ihre Objekte einen Betreuer haben, der die Vermietung abwickelt, den Kontakt mit dem Gast herstellt, den Schlüssel übergibt etc., dann können Sie diesen hier eintragen. Die Kontaktdaten werden in der Buchungsbestätigung an den Gast übermittelt. Das Kontaktfeld ist ein Freitextfeld, in welches Sie am besten eine Mobilnummer, oder auch Festnetz und E-Mail Adresse eintragen, je nach dem worüber Ihr Betreuer am direktesten erreichbar ist.",
  changeBtnMsg:
    '(Der "Speichern-Button" wird erst aktiv (blau), wenn alle Pflichtfelder und die Bankverbindung ausgefüllt wurden.)',
  mdHostChangeMsg:
    "Hinweis:  \nWenn Sie Benutzerdaten oder Bankverbindung ändern, müssen Sie dies durch die Eingabe des Passwortes bestätigen!",
  smsNotification: "SMS Benachrichtigung",
  mdSmsNotificationMsg:
    "Wir bieten den Service, dass Sie bei einer Buchung eine SMS-Benachrichtigung in Kurzform mit allen wichtigen Buchungsdaten erhalten. Dies zusätzlich zu der kompletten Buchungsbestätigung per Email. Dadurch sind Sie sofort informiert ohne erst die Email zu lesen. Tragen Sie dafür bitte hier eine Mobilnummer ein:",
  backToPublish: "Zurück zur Veröffentlichung",

  //hostBankData
  bankAccountHolder: "Kontoinhaber",
  accountNumber: "Kontonummer",
  bankCode: "Bankleitzahl",
  bankName: "Name der Bank",
  bankIBAN: "IBAN",
  bankBIC: "BIC-Code",
  sepaMandate: "Zahlungsart wählen und ggf. Einzugsermächtigung (SEPA-Mandat)",
  mdSepaInfoMsg: `Wir erstellen immer am 24sten des lfd. Monats unsere Gastgeberabrechnungen, die Sie per E-Mail als .pdf-Anhang in Form einer finanzamtsfähigen Rechnung erhalten. Sie prüfen diese bitte und geben uns ggf. Änderungen durch, falls eventuell eine Gastabrechnung fehlerhaft sein sollte.

  Bei Zahlung per Rechnung überweisen Sie bitte den Rechnungsbetrag und bei Lastschrift buchen wir einige Tage später unser Honorar von Ihrem Konto ab. Sie haben damit keine Arbeit und können Lastschriften auch noch 8 Wochen nach Abbuchung ohne Grund zurückgeben. Das macht SEPA-Lastschrifteinzüge für Sie sicher und unkompliziert.`,
  invoiceConfirm: "Ich überweise den Rechnungsbetrag nach Erhalt der Rechnung",
  debitConfirm:
    "Ich möchte am Lastschriftverfahren teilnehmen und erteile hiermit urbanbnb die Erlaubnis, die monatlich anfallenden Honorare bis auf weiteres per Lastschrift einzuziehen.",

  // hostAddresses
  addAddress: "Objekt anlegen",
  addressNameTooltip:
    "Finden Sie eine schöne Bezeichnung für Ihr Zimmer oder Ihre Wohnung. Zum Beispiel: „ wunderschönes und ruhiges Gästezimmer“. Oder „moderne und zentrumsnahe Wohnung“",
  deleteAddress: "Objekt löschen",
  deleteAddressMsg: "Möchten Sie das Objekt wirklich löschen?",

  // hostAddressProperties
  object: "Objekt",
  properties: "Eigenschaften",
  propertiesAndLocation: "Eigenschaften / Lage",
  location: "Lage",
  invoices: "Rechnungen",
  nameOfObject: "Wie soll ihr Objekt inseriert werden",
  countryOfObject: "In welchem Land befindet sich ihr Objekt",
  cityOfObject: "In welcher Stadt befindet sich ihr Objekt",
  addressOfObject: "Adresse ihres Objektes",
  addressNotFound: "Adresse nicht gefunden",
  trafficConnectionMsg: `Bitte beschreiben Sie alle Infos wie ein Gast die öffentliche Verkehrsmittel benützen kann, Parkplatzsituation vor Ort (eigener Parkplatz, Art oder auf Strasse parken, kostet das etwas, Anwohnerparkplatz etc).
  Notieren Sie auch wie weit zum Bus/Bahn im Meterangabe, welche Bus/Bahn fährt dann wohin, wie weit ist es zum Zentrum. Gibt es bekannte Firmen in der Nähe – bitte angeben mit km-Entfernung dorthin. Fahrradabstellmöglichkeiten?`,
  trafficConnection_de: "Verkehrsanbindung - Deutsch",
  trafficConnection_en: "Verkehrsanbindung - Englisch",
  tipsForArea_de: "Tipps - Deutsch",
  tipsForArea_en: "Tipps - Englisch",
  currencyOfObject: "Währung für das Objekt",
  activateMapBoxCookie:
    "Bitte aktivieren Sie den MapBox Cookie. Sie können dies über den Cookie Button rechts in der Sidebar tun.",

  // hostAddressRoomtypes
  roomtypes: "Unterkünfte",
  mdRoomtypesInfo: `### Unterkünfte (Zimmer und Wohnungen)

  Hier legen Sie Ihr eines oder die unterschiedlichen Zimmer und Wohnungen innerhalb eines Objektes/Gebäudes an. Sollten Sie mehrere identische Zimmer haben, dann legen Sie hier nur eines davon an und können in einem späteren Schritt "Zimmer gleicher Art" hinzufügen, also praktisch die Anzahl dieses Zimmers angeben)`,
  addRoomtype: "Unterkunft anlegen",
  editRoomtype: "Unterkunft bearbeiten",
  hideRoomtype: "Unterkunft deaktivieren",
  deleteRoomtype: "Unterkunft löschen",
  noTitle: "Ohne Name",
  deleteRoomtypeMsg: "Möchten Sie die Unterkunft wirklich löschen?",
  hideRoomtypeMsg:
    "Die Unterkunft kann anschließend über die Suche nicht mehr gefunden werden. Um sie wieder sichtbar zu machen muss die Unterkunft erneut publiziert werden.",
  roomtypeHidden: "Unterkunft ist deaktiviert",
  roomtypeVisible: "Unterkunft ist öffentlich",

  // hostAddressBookings
  bookings: "Buchungen",
  guest: "Gast",
  arrival: "Anreise",
  departure: "Abreise",
  days: "Tage",
  noBookings: "Keine Buchungen vorhanden",
  backToBookingOverview: "Zurück zur Buchungsübersicht",

  // bookingView
  guestContact: "Gast Kontaktdaten",
  reservationDetails: "Reservierungsdetails",
  priceDetails: "Preisdetails",

  // hostAddressInvoices
  rent: "Mietpreis",
  invoice: "Rechnung",
  commission: "Provision",
  invoiceDate: "Rechnungsdatum",
  accountingPeriod: "Abrechnungszeitraum",
  showInvoice: "Rechnung anzeigen",
  noInvoices: "Keine Rechnungen vorhanden",

  // hostRoomtype
  quarter: "Unterkunft",
  description: "Beschreibung",
  media: "Fotos und Videos",
  features: "Ausstattungsmerkmale",
  bookingTimes: "Buchungszeiträume",
  name_de: "Deutsche Kurzbeschreibung",
  name_en: "Englische Kurzbeschreibung",
  description_de: "Beschreibung Deutsch",
  description_en: "Beschreibung Englisch",
  backToRoomtype: "Zurück zur Unterkunft",
  preview: "Vorschau",
  previewMode: "Vorschaumodus",
  previewFailMsg:
    "Die Vorschau ist erst möglich wenn die Preise vollständig eingegeben wurden.",
  publishRoomtype: "Unterkunft veröffentlichen",
  roomtypeGotUnpublishedMsg:
    "An der Unterkunft wurden solche grundsätzlichen Änderungen vorgenommen, dass diese neu veröffentlicht werden muss. Stellen Sie bitte sicher, dass im linken Menü alle notwendigen Angaben ergänzt wurden und alle Punkte grün markiert sind. Ohne erneute Veröffentlichung bleibt die Unterkunft deaktiviert und wird nicht angezeigt.",
  roomtypeGotUnpublishedTitle: "Unterkunft bitte neu veröffentlichen",
  mdRoomtypePublished: `Ihre Unterkunft ist nun online und ab sofort für Gäste buchbar.${s}
  Wir freuen uns auf viele Gästebuchungen mit Ihnen.

  Ihr urbanbnb Team`,
  lastMinute: "Last-Minute Buchung",

  staticFeatures: {
    residenceRegistration: "Wohnsitzanmeldung möglich",
    residenceRegistrationTooltip:
      "Gastgeber sind gesetzlich verpflichtet, die Wohnsitzanmeldung zu ermöglichen.",
    invoicePossible: "Rechnungsstellung machbar",
    invoicePossibleTooltip:
      "Alle unsere Gastgeber stellen Ihnen selbstverständlich eine steuerlich anerkannte Rechnung aus. In der Regel erfolgt dies ohne Mehrwertsteuer für Privatpersonen. Sollte jedoch der Gastgeber als gewerblicher Anbieter markiert sein, wird die Rechnung mit Mehrwertsteuer ausgestellt.",
  },

  // hostRoomtypePublish
  cantPublish:
    "Ihre Unterkunft kann noch nicht veröffentlicht werden, da die Angaben noch nicht vollständig sind. Stellen sie sicher, dass im Menü alle Punkte grün markiert sind.",
  mdPublishNeedsBankInfo: `**Bitte wählen Sie jetzt Ihre Zahlungmethode und tragen Ihre Bankverbindung bei Lastschriftermächtigung in Ihren Account ein.**`,
  toDetailsPage: "Zur Detailseite",
  toObjectsPage: "Zu Ihren Objekten",
  isPublished: "Unterkunft veröffentlicht",

  // old hosts with >10%
  mdNearlyFinishedOldHost: `**Fast fertig**

  Das Einstellen Ihres Inserates ist kostenlos. Wir berechnen nur bei einer erfolgreichen Gastbuchung Ihres Objektes eine Servicegebühr anteilig vom reinen Übernachtungspreis. Das heisst, Serviceentgelte, die der Gast zusätzlich noch an Sie bezahlt wie Internet, Reinigung, Frühstück, Parkplatz, Haustier etc. sind selbstverständlich allein Ihr Geld.`,

  // new hosts with 10%
  mdNearlyFinished: `**Fast fertig**

  Das Einstellen Ihres Inserates ist kostenlos. Wir berechnen nur bei einer erfolgreichen Gastbuchung Ihres Objektes eine Servicegebühr in Höhe von 10% (plus MwSt.) vom reinen Übernachtungspreis. Das heisst, Serviceentgelte, die der Gast zusätzlich noch an Sie bezahlt wie Internet, Reinigung, Frühstück, Parkplatz, Haustier etc. sind selbstverständlich allein Ihr Geld.`,

  // new hosts with only direct debit
  mdFeeDebitMsg: `**Honorarabrechnung**

  Wir erstellen immer am 24sten des laufenden Monats unsere Gastgeberabrechnungen, die Sie per E-Mail als .pdf-Anhang in Form einer finanzamtsfähigen Rechnung erhalten. Sie prüfen diese bitte und geben uns ggf. Änderungen durch, falls eventuell eine Gastabrechnung fehlerhaft sein sollte. Um Ihnen und uns die Arbeit zu erleichtern, möchten wir unsere Honorar per Lastschrift abbuchen. Damit ersparen wir uns auch eine Rechnungseingangskontrolle. Zudem ist dies auch ein Sicherheitsmerkmal für Gäste, wo wir wissen, das es Sie als Gastgeber tatsächlich gibt und Sie ein Bankkonto haben. Bitte tragen Sie hier Ihre Bankverbindung ein. Sie geben uns damit die Erlaubnis, die monatlich anfallende Honorare bis auf weiteres per Lastschrift einzuziehen. Diese Erlaubnis können Sie jederzeit formlos widersprechen. Lastschriften auch noch 8 Wochen nach Abbuchung ohne Grund zurückgeben. Das macht SEPA-Lastschrifteinzüge für Sie sicher und unkompliziert.`,

  // hostRoomtypeProperties
  roomtypeNameMsg: `Bitte hier in Stichworte die wesentliche Merkmale Ihres Objektes erwähnen. Diese ist die Überschrift über Ihren Eintrag und in der Suche das erste was der Gast liest. Beispiel für einen Text:
"Gästezimmer in Stuttgart-Möhringen Nähe Musical mit Internet, TV, Etagendusche/Wc und Teilung Küche, Waschmaschine" oder "1-Zimmer Ferienwohnung in Berlin-Tegel mit TV, Internet, Balkon, Küchenzeile, Dusche/Wc, Parkplatz, Nähe S-Bahn".`,

  // hostRoomtypeDescription
  descriptionMsg:
    "Damit sich Ihre zukünftigen Gäste ein genaues Bild von Ihrer Unterkunft machen können, ist es wichtig, dass Sie Ihr Objekt gut beschreiben. Geben Sie auch unbedingt an, wenn Sie ein TV oder Internet zur Nutzung anbieten, welche Art von TV oder Internetanschluss das ist (SAT, Kabel, DVB-T, W-LAN, usw). Beschreiben Sie auch die Parksituation nahe der Unterkunft, ggf. auch die Möglichkeit mit öffentlichen Verkehrsmitteln zu fahren.",
  mdDescriptionInfo:
    "Hinweis: Bitte beachten Sie, dass die Beschreibung nur dann gespeichert werden kann, wenn sie sowohl in deutscher als auch in englischer Sprache vorliegt. Die integrierten Übersetzungsknöpfe stehen Ihnen zur Unterstützung bei der Übersetzung zur Verfügung.",
  incompleteMsg: "Noch nicht vollständig",

  // hostRoomtypeFeatures
  optionalFeaturePriceMsg:
    "Wenn eine dieser Leistungen bei Ihnen inklusive ist und Sie keine extra Gebühr dafür verlangen, dann lassen Sie die Preisfelder einfach leer und tragen gar nichts ein. Dann wird es dem Gast auch nicht als kostenpflichtig angezeigt.",
  noPaidFeaturesMsg:
    "Es wurden keine kostenpflichtigen Ausstattungsmerkmale ausgewählt.",
  mdFeaturePriceHint: `Wenn Sie eine Orientierung benötigen, empfehlen wir Ihnen folgende Preise:`,

  // hostRoomtypePrices
  mdRoomtypePriceMsg: `Der Übernachtungspreis sollte Ihrem angegeben Objekt entsprechen. Falls Sie unsicher sind, welchen Preis Sie berechnen sollen, fragen Sie uns. Gerne erstellen wir Ihnen eine Preiskalkulation.

  Urbanbnb-Tipp: Ein zu hoher Preis kann zu einer schlechteren Auslastung führen. Vielleicht möchten Sie für Ihre ersten Urbanbnb Gäste einen günstigen Preis anbieten, um auf Ihr Objekt aufmerksam zu machen. Die Preise sind Pflichtfelder und können nachträglich jederzeit angepasst werden.`,
  cleaningInfo: "Info zur Reinigung",
  roomtypeIntermediateCleaningMsg: `Falls Sie Ihr Objekt alle 14 Tage selbst reinigen oder reinigen lassen, dann bitte hier eine Summe eintragen, die der Gast extra zusätzlich bezahlt.`,
  roomtypeFinalCleaningMsg: `Diese wird immer berechnet, egal ob Sie eine Zwischenreinigung anbieten oder nicht. Diese findet nach dem Auszug des Gastes statt, ist also eine einmalige Gebühr, die der Gast extra bezahlt. Unabhängig von der Dauer und wird bei Anreise gleich mit bezahlt. Bitte tragen Sie hier diese Endreinigungsgebühr ein.`,
  mdRoomtypeCleaningMsg: `Eine Endreinigungsgebühr wird immer berechnet, einmalig und gleich bei Buchung ausgewiesen, sodass der Gast informiert ist mit Summe etc.  und wird bei/vor Anreise gleich mitbezahlt.

14-tägige Zwischenreinigung:
Dies ist optional. Ist eine organisatorische Frage, ob Sie eine Zwischenreinigung machen wollen oder können. Vorteil einer Zwischenreinigung ist, dass Sie alle 14 Tage in Ruhe Ihr Objekt prüfen können dabei und falls es Fehlentwicklungen oder Mängel gibt, frühzeitig darauf reagieren und uns informieren können. Wir sprechen dann mit dem Gast. Zwischenreinigung umfasst nur eine Grundreinigung ohne Geschirr, eventuell mit Bettwäsche- und Handtücherwechsel.
    `,
  mdCleaningPriceMsg: `(Empfohlene Reinigungsgebühr bei einem Gästezimmer: 2 €/Nacht und 30 €/mtl. Empfohlene Reinigungsgebühr bei einer Wohnung: 4 €/Nacht und 50 €/mtl. Bei einer größeren Wohnung entsprechend mehr.)`,
  mdFeaturePriceMsg: `Zusätzliche Serviceleistungen wie Internet, Parkplatz, Frühstück, Waschmaschine etc. – bitte Preise links bei Navigationspunkt Ausstattungsmerkmale ganz unten eintragen.`,
  childrenPriceMsg:
    "Kinder bis 12 Jahre zahlen je Nacht 2 Euro weniger und je Monat 30 Euro weniger als Erwachsene. Diese Vergünstigung wird in der Berechnung des Gesamtpreises automatisch mit eingerechnet, wenn die Anzahl der Kinder angegeben wurde.",

  // hostRoomtypeBookingOptions
  minDays: "Min. Buchungsdauer",
  maxDays: "Max. Buchungsdauer",
  oneIn3Days: "innerhalb von 3 Tagen",
  oneIn2Months: "innerhalb von 2 Monaten",
  mdMinBookingDaysMsg: `
  Tipp: Unsere Gäste sind überwiegend aus beruflichen Gründen in Ihrer Stadt.${s}
  Wir empfehlen auch aus wirtschaftliche Gründen ein Gästezimmer erst ab mindestens 2 Übernachtungen buchbar zu machen. Eine Wohnung erst ab mindestens 5 Übernachtungen. Andernfalls haben Sie einen unverhältnismässigen hohen Aufwand mit Check in, Check out, Reinigung, Bettwäschewechsel usw..`,

  mdMaxBookingDaysMsg: `
  Bei der Max. Buchungsdauer geben Sie die Anzahl der Tage an, die Ihr Objekt maximal gebucht werden kann. Auch dieses Feld können Sie leer lassen, wenn die Gäste bei Ihnen länger als einen Monat buchen dürfen.`,

  mdOneNightBookingMsg: `Da viele Gastgeber erfahrungsgemäß die 1-Nacht-Bucher nicht so gerne haben, geben wir Ihnen hier die Möglichkeit zu entscheiden, ob Sie Ihr Objekt auch nur für eine Nacht buchen können. Das richtet sich vor allem an Gastgeber, die z.B. Monteure für mehrere Wochen beherbergen wollen. Denn wenn dann z.B. innerhalb von 2 Monaten ein Gast mit nur 1-Nacht Buchung gebucht hat, ist das Objekt für den langen Zeitraum blockiert.

  Wenn allerdings der Gast nur eine Nacht innerhalb der nächsten 3 Tage buchen möchte, dann können Sie das mit dieser Option "inerhalb 3 Tage" ermöglichen.

  Standardmäßig sind 1-Nacht-Buchungen nicht möglich, wenn Sie diese nicht erlauben.`,

  mdLastMinuteMsg: `Viele unsere Geschäftsreisende buchen sehr kurzfristig. Zum Beispiel Montags buchen und Montag Abend anreisen. Wenn Sie Last-Minute Buchung freigeben, bedeutet das, dass der Gast sich Ihr Objekt am gleichen Tag aussuchen, buchen und dann noch am selben Abend anreisen kann (Ankunftszeit in Absprache mit Ihnen). Wenn dies für Sie organisatorisch machbar ist, sollten Sie Last-Minute-Buchung annehmen, weil dadurch eine hohe Zimmerauslastung ermöglich wird. Bei Buchung erhalten Sie auch immer per Email und SMS die Buchungsdaten, sodass Sie gleich mit dem Gast in Kontakt treten können für Absprache zur Anreise/Schlüsselübergabe.`,
  allowLastMinute: "Last-Minute Buchung zulassen",

  // hostRoomtypeRooms
  manageRooms: "Zimmerverwaltung Belegungskalender / Buchungssperren",
  roomNumberOrName: "Zimmer-Nr. oder Name",
  addRoomsOfThisKind: "Zimmer dieser Art hinzufügen",
  deleteRoom: "Zimmer löschen",
  deleteRoomMsg: "Möchten Sie dieses Zimmer wirklich löschen?",
  mdRoomExplanation: `In der Zimmerverwaltung ist nun ein Zimmer von Ihnen angelegt. Dieses wird mit der Nummer 1 angezeigt.

  Möchten Sie kein weiteres Zimmer dieser Art anlegen, dann gehen Sie einfach auf „weiter“. Mit *Bearbeiten* können Sie die Zimmernummer ändern, falls Sie vor Ort Namen oder andere Nummern für ihre Unterkünfte haben, damit die Zuordnung leichter ist.

  Wenn Sie mehrere gleichartige Zimmer oder Wohnungen haben, dann haben Sie nun das Zimmer/Wohnung hier einmal angelegt und können nun weitere Zimmer/Wohnungen gleicher Art hinzufügen. Für diese können Sie unterschiedliche Nummern oder Namen vergeben, damit Sie im Belegungskalender später diese Zimmer unterscheiden können bzw. Ihre Zimmernummierung vor Ort gleichlautend ist.`,

  manageRoomMsg:
    "Grundsätzlich können Sie in der Zimmerverwaltung den Belegungskalender sehen und Ihre eigenen Buchungssperren eintragen, z.B. wenn Sie im Urlaub sind.",

  // hostRoomReservations
  reservationCalendarShort: "Belegungskalender",
  reservationCalendar: "Belegungskalender / Buchungssperren",
  booked: "Gebucht",
  blocking_ad: "An- und Abreisesperre",
  blocking_full: "Buchungssperre",
  option: "Verlängerungsoption",
  option_ok: "Verlängerungsoption",
  blockingAdTooltip:
    'Wenn Sie z.B. eine Woche im Urlaub sind, dann könnten Sie Ihre Unterkunft in dieser Zeit trotzdem vermieten. Sie müssten jeweils nur bei der Anreise und bei der Abreise des Gastes wieder Vorort sein. In diesem Zeitfenster der An-/Abreisesperre darf also kein Buchungsanfang und kein Buchungsende liegen. Über diesen Zeitraum kann praktisch aber "hinweggebucht" werden.',
  blockingFullTooltip:
    "Hier tragen Sie einfach den Zeitraum ein, in welchem Ihre Unterkunft nicht zur Vermietung steht. Gründe dafür können Urlaub, Renovierung, Eigenbelegung oder anderweitige Vermietung sein.",
  chooseBlockingType: "Bitte Art der Sperre auswählen",
  blockingReason: "Sperrgrund",
  blockingFrom: "Sperre von",
  blockingTo: "Sperre bis",
  createBlocking: "Sperre anwenden",

  ownBooking: "Eigenbelegung",
  backToReservationCalendar: "Zurück zum Belegungskalender",

  // hostRoomtypeMedia
  mdMediaInfo: `**Wichtig:** Fotos sollten immer Querformat haben. Wenn Sie mit Handy aufnehmen, drehen Sie bitte Ihr Handy und nehmen bitte nicht in Hochformat auf.  Machen Sie auch ungewöhnliche Fotos, also zum Fenster rein, vom Boden aus am Bett vorbei, von Ecke von oben den ganzen Raum. Bitte keine Fotos, die im Dunkeln aufgenommen worden sind. Tageslicht ist besser. Bäder/Wc – auch hier gilt Querformat, kleine Räume kann man gut von oben aufnehmen aus der Ecke heraus. Fotos sind Ihre Visitenkarte, bitte daher Zeit nehmen und attraktive Fotos erstellen.

  **Videos:** Gäste sehen vermehrt Besichtigungsvideos an. Gerne können Sie uns Ihr selbstgedrehtes Video senden. Einfach mit dem Handy aufnehmen, Dauer circa 10-15 Sekunden. Senden Sie den Film uns per Email oder am besten per Whatsapp. Wir bearbeiten es weiter und setzen es hier ein. Ein Video von Ihrem Objekt empfehlen wir Ihnen sehr, denn Gäste lesen immer weniger Texte, sondern möchten mehr visuelle Infos zum Objekt erfahren. Daher bitte erstellen und uns senden. Wenn Sie einen Youtube-Kanal haben, können Sie auch gerne die Youtube-Video URL hier selber einfügen.`,
  addPhoto: "Foto hinzufügen",
  addVideo: "Video hinzufügen",
  addPanorama: "360°-Foto hinzufügen",
  videoNotFound: "Kein Video gefunden",
  showInSlider: "Als Großformat auf Detailseite",
  showInSliderTooltip:
    "Sie können die Fotos auswählen, welche auf der Detailseite oben als Großformat angezeigt werden sollen. Alle anderen Bildern werden in der Bildergalerie der Detailseite in normaler Größe angezeigt.",
  addMediaItem: "Neues Foto, Video oder 360°-Foto hinzufügen",
  uploadNewEntries: "Neue Fotos/Videos hochladen",
  mdVideoContact: `Gerne laden wir die Videos für Sie hoch, bitte senden Sie uns dafür eine E-Mail an [info@urbanbnb.de](mailto:info@urbanbnb.de). Wir senden ihnen dann einen personalisierten Link über welchen Sie uns das Video zusenden können. Wir stellen das Video dann für Sie ein.

  Wenn sie bereits eine Youtube-URL haben, dann können Sie sie im folgenden Dialog eintragen.
  `,
  mdMediaTitleInfo:
    "Sie können den Bildernamen vor dem Upload noch anpassen. Dieser wird auch als Bildtitel und Mouse-Over-Text angezeigt.\n\nEr sollte für die Suchmaschinen Schlüsselwörter enthalten, z.B. Unterkunft-in-Stuttgart-Zentrum-01.jpg",
  mdImageInfo:
    "Sie können zudem selbst festlegen, welche Bilder auf der Detailseite ganz oben vollflächig im Großformat-Slider angezeigt werden.\n\nBitte achten Sie darauf, dass die Bilder groß genug sind (Empfehlung: 2500 Pixel breit = ca. 1 MB Dateigröße)\n\nDie Bildgröße bei 360°-Fotos muss 3000 x 1500 Pixel betragen!\n\n*Link:*&nbsp; [6 weitere Tipps für Fotos](https://bedbreakfaststuttgart.blogspot.de/2016/07/6-tipps-fur-gute-bilder-von-ihrem.html)",
  mdMoveInfo:
    "Die Reihenfolge der Bilder können Sie nachträglich ändern, indem Sie das Bewegen-Symbol anfassen und die Bilder einfach verschieben.",
  mdUploadInfo:
    'Wenn Sie die Fotos, Youtube-Videos oder 360°-Fotos zum Upload ausgewählt haben, klicken Sie bitte unten auf den Button "Neue Einträge hochladen"',
  noteImageUpload: "Hinweis Bilderupload",
  noteFilename: "Hinweis Dateiname",
  noteImagesize: "Hinweis Bildgröße",
  noteImageorder: "Hinweis Reihenfolge",
  chooseFile: "Datei auswählen",
  defaultViewSelected: "Standardansicht gewählt",
  chooseDefaultView: "Standardansicht festlegen",
  previewSelected: "Vorschaubild gewählt",
  choosePreviewImage: "Vorschaubild festlegen",

  // cancellation
  cancelBooking: "Stornierungsanfrage",
  mdCancelMsg:
    "Bitte teilen Sie uns Ihre Stornierung im nachfolgenden Feld oder per E-Mail mit und beachten die in den [AGBs](https://www.urbanbnb.de/page/de/agbs?lang=de#agbs_08) festgehaltenen Stornierungsbedingungen und die Kosten, die durch eine Stornierung entstehen können.",
  cancelReason: "Stornierungsgrund",
  cancelNow: "Stornierungsanfrage absenden",

  // complaint
  bookingComplain: "Beschwerde einreichen",
  complaintReason: "Beschwerdegrund",
  complaintMsg:
    "Sie sind nicht zufrieden mit Ihren gebuchten Objekt? Haben Sie Grund zur Beschwerde? Bitte teilen Sie uns schriftlich mit was Ihnen nicht zusagt. Wir werden Ihren Gastgeber darüber informieren und versuchen zu vermitteln.",
  hostComplaint: "Ich habe meinem Gastgeber die Beschwerde bereits mitgeteilt",
  hostComplaintMsg:
    "Meist hilft es, zuerst mit Ihrem Gastgeber über Ihre Beschwerde zu sprechen. Oft lässt sich im persönlichen Gespräch vieles klären und Mängel können meist schnell behoben werden.",
  complaintLabel: "Beschreibung / Beschwerdegrund:",

  // rate
  rateBooking: "Unterkunft bewerten",
  rateNow: "Bewertung absenden",
  hostRatingHint:
    "Aus Datenschutzgründen möchten wir Sie bitten, den Namen Ihres Gastgebers nicht zu erwähnen. Auch Ihre Privatsphäre ist geschützt mit Namenskürzel.",

  // extend
  bookingExtend: "Buchung verlängern",
  extendMsg:
    "Sie möchten Ihren Aufenthalt in der nebenstehenden Unterkunft verlängern?",
  extendNow: "Jetzt verlängern",

  // hostRoomtypeAdd
  descriptionOfRoomtype: "Überschrift der Unterkunft",
  roomtypeNameTooltip:
    "Bitte vergeben Sie einen Namen/Bezeichnung für diese spezielle Unterkunft (Zimmer oder Wohnung) Objekt z.B. Gästezimmer mit TV, eigener Dusche/Wc, Gästeküche, Internet oder 1-Zimmerwohnung mit Küche, Du/Wc, TV, Internet. Diese Bezeichnung wird dann in der Ergebnisliste angezeigt. Stöbern Sie nach ähnlichen Unterkünften und schauen welche Bezeichnungen verwendet wurden.",

  // blog
  blog: "urbanbnb Blog",
  blogDescription:
    "Entdecke das urbane Wohnen auf Zeit mit Urbanbnb: Von möblierten Apartments in Stuttgart, Karlsruhe bis Köln und darüber hinaus. Unser Familienunternehmen teilt Wissenswertes zu temporärem Wohnen, urbanem Zeitwohnkonzept, Zwischenmiete sowie wichtigen Aspekten wie steuerlichen Fragen, gesetzlichen Änderungen und Ausstattungstrends.",
  blogSeoTitle: "Urbanes Wohnen auf Zeit mit Urbanbnb",
  blogSeo:
    "<p>In der dynamischen Welt des temporären Wohnens präsentiert Urbanbnb einen informativen Blog, der sich über die Städte Stuttgart, Karlsruhe, Köln und weitere erstreckt. Das Familienunternehmen teilt sein Fachwissen zu essentiellen Themen wie möblierte Apartments, Wohnung auf Zeit, urbanes Zeitwohnkonzept und Zwischenmiete.</p> <p>Der Blog bietet nicht nur Einblicke in die neuesten Entwicklungen in diesen Städten, sondern behandelt auch wichtige Aspekte für Vermieter, darunter steuerliche Fragen, gesetzliche Änderungen und Trends in der Wohnungsausstattung. Urbanbnb positioniert sich als verlässlicher Partner für zeitgemäßes Wohnen und informiert seine Leserüber alle relevanten Facetten des temporären Wohnens.</p> <p>Die präzise und verständliche Berichterstattung ermöglicht es Lesern, sich umfassend zu informieren und die Vorzüge des urbanen Zeitwohnens zu verstehen. Mit einem Fokus auf mehreren Städten bietet Urbanbnb einen ganzheitlichen Blick auf die Herausforderungen und Möglichkeiten des Wohnens auf Zeit in unterschiedlichen urbanen Umgebungen.</p> <p>Die Blogtexte sind sorgfältig recherchiert, aktuell und geben klare Einblicke in die Welt deszeitgemäßen Wohnens. Urbanbnb verfolgt das Ziel, nicht nur temporären Mietern, sondern auch Vermietern eine wertvolle Informationsquelle zu bieten. Der Blogdient als Plattform für Wissenstransfer, umfassende Beratung und als Anlaufstelle für alle, die sich für die dynamische Welt des urbanen Wohnens interessieren.</p> <p>Urbanbnb hebt sich als kompetenter Ansprechpartner für zeitgemäßes Wohnen hervor und stärkt seine Position durch die kontinuierliche Bereitstellung relevanter Informationen. Der Blog steht allen Interessierten offen und bietet eine reiche Quelle an Wissen und Orientierung für diejenigen, die temporäres Wohnen in den genannten Städten in Betracht ziehen.</p> <p>Für weitere Informationen und tiefergehende Einblicke in das urbane Wohnen auf Zeit empfehlen wir einen Besuch auf dem Urbanbnb Blog.</p><p>Pressekontakt: Urbanbnb Presseteam E-Mail:<a href='mailto:info@urbanbnb.de'>info@urbanbnb.de</a> </p> <p>Über Urbanbnb: Urbanbnb ist ein etabliertes Familienunternehmen, das sich auf temporäres Wohnen und möblierte Apartments spezialisiert hat. Mit einem urbanen Zeitwohnkonzept bietet Urbanbnb flexible Lösungen für zeitgemäßes Wohnen in verschiedenen deutschen Städten. Weitere Informationen finden Sie auf www.urbanbnb.de.</p>",
  archive: "Archiv",
  topics: "Themen",
  showAll: "alles anzeigen",
  back: "Zurück",
  noMoreEntries: "Keine weiteren Einträge",
  copiedToClipboard: "URL kopiert in Zwischenablage",

  // cookieNotice
  mdCookieNotice:
    "Cookies erleichtern die Bereitstellung unserer Dienste. Mit der Nutzung unserer Dienste erklären Sie sich damit einverstanden, dass wir Cookies verwenden.",

  // coronaMessage
  coronaMessage: "Sicher übernachten in Corona-Zeiten",
  coronaButton: "weitere Infos",
  coronaTitle: "Die Welt hat derzeit einen ungebetenen Gast - das Coronavirus.",
  mdCoronaMessage: `**Aktuell 16.08.2021:**  
  In Baden Württemberg ist  seit dem gestrigen Tag eine neue Corona Verordnung in Kraft  getreten. Dementsprechend müssen alle Beherbergungsgäste bei Check Inn einen gültigen  3 G Nachweis erbringen. Sollten Gäste auf Basis eines Tests einchecken, muss dieser  alle  3 Tage erneuert und vorgelegt werden.  
  Anbei der Link zu der Verordnung: <https://www.baden-wuerttemberg.de/de/service/alle-meldungen/meldung/pid/corona-beschraenkungen-fuer-geimpfte-und-genesene-werden-weitgehend-aufgehoben/>  
  **Unsere Corona-Schutzmaßnahmen für Ihre und die Sicherheit unserer Gastgeber/in:**
  ${s}

  Alle Zimmer und Wohnungen werden vor Ihrer Ankunft gründlich mit speziellen Reinigungsmitteln penibel gesäubert. Besonderes Augenmerk bei der Reinigung wird auf die Flächen im Bad, WC/ Dusche/ der Gästeküche sowie der Nachttische und Geräte des täglichen Bedarfs wie die Fernbedienung des TV-Geräts gelegt.


  Wenn Sie eine Wohnung gebucht haben, wird Ihr Gastgeber/in Ihnen diese sauber und gereinigt übergeben. Während Ihrer Anmietungszeit können Sie mit Ihrem Gastgeber/in vereinbaren, dass diese die Wohnung für eine Zwischenreinigung, nicht betritt.

  
  Bitte halten Sie bei Ihrer Ankunft zu Ihrem Gastgeber den vorgeschriebenen Sicherheitsabstand von 1,5 Meter ein und bedecken Sie Mund und Nase, auch Ihr Gastgeber wird dies tun. Die Bezahlung der Miete sollte, wenn möglich Bargeldlos erfolgen. Dazu klären Sie bitte vor Ihrer Anreise telefonisch die Bankdaten Ihres Gastgebers für die Überweisung der Miete und Kaution. Den Nachweis dafür halten Sie bitte bei Anreise bereit.`,

  urbanLagerButtonText: "Noch Lagerraum benötigt?",
  urbanLagerTeaserText: "Jetzt privaten Keller oder Abstellraum ergänzend zur Wohnung mieten – urban-Lager.de",
  errors: {
    generic: "Ein Fehler ist aufgetreten",
    rate: "Beim Absenden der Bewertung ist ein Fehler aufgetreten",

    "features.save":
      "Beim Speichern der Ausstattungsmerkmale ist ein Fehler aufgetreten",
    "host.change": "Beim Ändern ihrer Daten ist ein Fehler aufgetreten",
    translation: "Das Übersetzen des Textes ist fehlgeschlagen",
    "translation.available":
      "Der Übersetzungsservice ist zurzeit leider nicht verfügbar",
    "terms.accept": "Bitte akzeptieren sie die AGBs um fortzufahren",
    "pdf.download": "Der PDF Download ist fehlgeschlagen",
    "media.delete":
      "Beim Löschen des Medieneintrags ist ein Fehler aufgetreten",
    "blocking.conflict":
      "Die Sperre konnte nicht angelegt werden, da sie sich mit einer bereits existierenden Buchung oder Sperre überschneidet.",
    "address.create": "Beim Anlegen der Adresse ist ein Fehler aufgetreten",
    "roomtype.create": "Beim Anlegen der Unterkunft ist ein Fehler aufgetreten",
    "room.save": "Beim Speichern des Zimmers ist ein Fehler aufgetreten",
    "room.delete": "Beim Löschen des Zimmers ist ein Fehler aufgetreten",
    "email.existing": "E-Mail wurde schon einmal verwendet",
    "email.email.": "Die E-Mail Adresse ist noch nicht vollständig angegeben.",
    "email2.email.":
      "Die weitere E-Mail Adresse ist noch nicht vollständig angegeben.",
    notValid: "Die Eingabe ist nicht gültig",
    "email.invalid": "Die E-Mail Adresse ist nicht gültig.",
    "phone.invalid": "Die Telefonnummer ist nicht gültig.",
    "email.required.": "Die Email Adresse ist ein Pflichtfeld.",
    "email.missing": "Die Email Adresse ist ein Pflichtfeld.",
    "lastname.required.": "Der Nachname ist ein Pflichtfeld.",
    "lastname.missing": "Der Nachname ist ein Pflichtfeld.",
    "firstname.required.": "Der Vorname ist ein Pflichtfeld.",
    "firstname.missing": "Der Vorname ist ein Pflichtfeld.",
    "title.missing": "Die Anrede ist ein Pflichtfeld.",
    "postcode.required.": "Die Postleitzahl ist ein Pflichtfeld.",
    "postcode.missing": "Die Postleitzahl ist ein Pflichtfeld.",
    "street.required.": "Die Straße ist ein Pflichtfeld.",
    "street.missing": "Die Straße ist ein Pflichtfeld.",
    "city.required.": "Die Stadt ist ein Pflichtfeld.",
    "city.missing": "Die Stadt ist ein Pflichtfeld.",
    "mobile.required.": "Die Mobilnummer ist ein Pflichtfeld.",
    "mobile.missing": "Die Mobilnummer ist ein Pflichtfeld.",
    "value.tooSmall": "Der Wert ist zu klein",
    "password.minsize": "Passwort muss mindestens 6 Zeichen lang sein",
    "password.required": "Das Passwort ist ein Pflichtfeld.",
    "password.missing": "Das Passwort ist ein Pflichtfeld.",
    "passwordConfirm.missing": "Die Passwort-Bestätigung ist ein Pflichtfeld.",
    "password.mismatch": "Passwörter stimmen nicht überein",
    "captcha.notActivated": "Bitte bestätigen Sie, dass Sie kein Roboter sind",
    "g-recaptcha-response.invalid": "Die Captcha-Überprüfung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "privacyPolicy.notAccepted":
      "Bitte akzeptieren Sie die Datenschutzerklärung",
    oldPassword: "Ihr Passwort ist nicht korrekt",
    "bankiban.match": "Das Format der eingegebenen IBAN ist nicht korrekt",
    "bankbic.match": "Das Format der eingegebenen BIC ist nicht korrekt",

    "sms.wrongcode": "Ungültigen Bestätigungscode eingegeben",
    400306: "Der gewählte Zeitraum liegt in der Vergangenheit",
    400903: "Ungültige Telefonnummer angegeben",
    400913: "Ihre eingegebene E-Mail-Adresse ist nicht gültig",
    401100: "Ihre Logindaten sind nicht korrekt",
    401102:
      "Ihr Account ist derzeit für die Onlinebuchung gesperrt. Dies kann verschiedene Gründe haben. Bitte senden Sie uns eine Email mit Ihrem Namen und Anliegen an: [info@urbanbnb.de](mailto:info@urbanbnb.de)",
    404101: "Keine Unterkünfte ausgewählt",
    409703: "Bewertung zu früh abgesendet",
  },
  bookingValidation: (code, minDays, maxDays) => {
    switch (code) {
      case 100:
        return "Unterkunft bereits reserviert";
      case 200:
      case 201:
      case 202:
        return `Minimale Buchungsdauer von ${minDays} Nächten unterschritten. Bitte suchen Sie nach einem anderen Objekt oder passen Ihren Buchungszeitraum an.`;
      case 300:
        return "Maximale Buchungsdauer überschritten";
      case 400:
        return "Minimaler Vorausbuchungszeitraum unterschritten";
      case 500:
        return "Lastminute-Buchung fehlgeschlagen";
    }
    return null;
  },
  countries: {
    DE: "Deutschland",
    AT: "Österreich",
    CH: "Schweiz",
    NL: "Niederlande",
    ES: "Spanien",
    PT: "Portugal",
    GR: "Griechenland",
  },
  mediaTypes: {
    image: "Bild",
    video: "Video",
    panorama: "360°-Foto",
  },
};

/* Englisch */
const localeEN = {
  delimiter: ".",
  lang: "en",
  monthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  dayNames: [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ],
  formatDate(date) {
    const d = new Date(date);
    return `${
      locale.en.monthNames[d.getMonth()]
    } ${d.getDate()}, ${d.getFullYear()}`;
  },

  whatsapp: {
    headline: "Questions? send whatsapp.",
  },

  // misc
  notfound: "Site not found",
  error: "Error",
  note: "Hint",
  hello: "Hello",
  welcome: "Welcome",
  ok: "Ok",
  cancel: "Cancel",
  yes: "Yes",
  no: "No",
  next: "Next",
  saveAndContinue: "Save & Continue",
  previous: "Back",
  print: "Print",
  required: "Required",
  edit: "Edit",
  save: "Save",
  editEntry: "Edit entry",
  saveEntry: "Save entry",
  removeEntry: "Remove entry",
  sendPerMail: "Send per e-mail",
  pleaseChoose: "Please choose",
  saveSuccess: "Saved successfully",
  saveFailure: "Save failed",
  loadMore: "Load more entries",
  more: "more",

  // translation
  translateToGerman: "Translate to German",
  translateToEnglish: "Translate to English",

  // userChat
  contactUs: "Contact us",

  // calendar
  today: "Today",
  pastDate: "past Date",

  // reservationCalendar
  reserved: "reserved",
  noBooking: "Booking not possible",
  minBooking: "Minimum booking duration",
  maxBooking: "Maximum booking duration",
  inBooking: "In booking period",
  bookingBegin: "Start of booking",
  bookingEnd: "End of booking",
  bookingTimespan: "Booking period",
  blockingTimespan: "Booking not possible",

  // static menu
  weAboutUs: "We about us",
  contact: "Contact",
  bookingProcess: "Booking process",
  visit: "Showing",
  arrivalInfo: "Information about arrivals",
  hostInfo: "Information for hosts",
  relocation: "Relocation + Visum & Address Registration Made Easy",

  // frontPage Search
  search: "Search",
  roomtypeNumber: "Id",
  enterRoomtypeNumber: "I know my host (accommodation ID)",
  roomtypeTooltip:
    "Note: The accommodation ID has been changed since the relaunch of the website. If you do not find the object by filtering, please ask for the new number per mail (info@urbanbnb.de).",
  findRoomtype: "Find accommodation",
  roomtypeExists: "Accommodation exists",
  roomtypeNotFound: "No Accommodation with this id was found!",
  onlineDiscountTooltip:
    "It works like this: Choose your room or apartment, book online and get a sales discount of 5 % from the accommodation price.",
  onlineDiscountMsg: "Book online and save 5 %",
  moveInImmediately: "Move in immediately",

  // results
  chooseCity: "Select city",
  noSearchResults:
    "We have not found any accommodation in the selected area. Please expand your search key.",
  chooseCityMsg:
    "Please choose a city or search for an address and select the best proposal.",
  results: "Results",
  printResults: "Print results",
  addRoomtypeToFavorites: "Add this accommodation to your favorites.",
  noGoogleMapsCookieSetInfoText:
    "The Google Maps service is currently blocked on this site!",
  noYoutubeCookieSetInfoText:
    "The Youtube service is currently blocked on this site!",
  setGoogleMapsCookie: "Allow Google Maps service now",
  setYoutubeCookie: "Allow Youtube service now",
  setMapBoxCookie: "Allow MapBox service now",
  mapBoxCookieNotAllowed: "MapBox service is currently blocked!",

  // header
  trustAndSecurity: "Trust and Security",
  guestLogin: "Guest login",
  guestArea: "Guestarea",
  becomeHost: "Become a host",
  mdLoginBecomeHost: `Log in or register here as a **host**!`,
  becomeHostNow: "Become a host now",

  // callcenterMode
  confirmAll: "Confirm all",
  sendOffer: "Send offer",

  // offer
  availableFavorites: (available, total) =>
    `${available} of your ${total} favorites are available in the selected booking period.`,

  // guestheader
  myData: "My Account",
  accountData: "Account Data",
  guestFaq: "Guest-FAQ",

  // hostheader
  hostLogin: "Host login",
  hostArea: "Host Area",
  hostFaq: "Hostinfo and FAQ",
  hostNews: "Host News",
  downloadCenter: "Download-Center",

  // footer
  guestTos: "Terms and Conditions for Guests",
  privacyPolicy: "Privacy statement",
  rightOfWithdrawal: "Right of Withdrawal",
  stuttgartInfo: "Stuttgart Info (only german)",
  berlinInfo: "Berlin Info (only german)",
  karlsruheInfo: "Karlsruhe Info (only german)",
  cologneInfo: "Cologne Info (only german)",
  imprint: "Imprint",

  // guestlogin
  mdGuestTeaser: `Register or login here as a **guest** to find accommodations!`,

  // hostlogin - redesign
  hostHeader1:
    "WG-Zimmer, möblierten Appartements, Ferienwohnungen, Monteurunterkünfte, Serviced Apartments, Pensionen – jetzt rentabel möbliert vermieten!",
  hostHeader2_1: "Ich bin",
  hostHeader2_2: "Claudia Urban",
  hostHeader2_3:
    "Ihre Expertin für möbliertes Zeitwohnen für Geschäftsreisende.",
  hostHeader3:
    "Ich zeige Ihnen, wie Sie ein erfolgreicher Gastgeber:in für Wohnen auf Zeit werden und unterstütze Sie dabei, Ihre Immobilie optimal auszulasten.",
  hostHeader4:
    "Urbanbnb – Ihr Familienunternehmen seit 1996 die Profis für Zeitwohnen.",

  hostSubnav1: "Profitabel vermieten – so geht’s",
  hostSubnav2: "Erfolgsrezept Zeitwohnen",
  hostSubnav3: "Podcast",
  hostSubnav4: "Über mich",
  hostSubnav5: "Blog Gastgeberthemen",

  hostSection1_1:
    "Wohnen auf Zeit ist kein Trend, sondern mittlerweile eine etablierte Wohnlösung für Geschäftsreisende und alle, die eine Zwischenlösung benötigen. Profitieren Sie als Gastgeberin für Zeitwohnen von dieser Entwicklung. Vermieten Sie lukrativ an Firmen und Geschäftsreisende und genießen Sie die vielen Vorteile als Gastgeberin für möblierte Wohnungen und Zimmer.",
  hostSection1Headline: "Was kann Urbanbnb für Sie tun?",
  hostSection1_2:
    "Als Familienunternehmen für Wohnen auf Zeit verfügen wir über ein enormes Potenzial an Erfahrung in der Branche der Kurzzeitvermietung. Wir sind erfolgreich in der Vermittlung von möblierten WG-Zimmern, Apartments und Monteurunterkünften. Als familiengeführtes Unternehmen legen wir großen Wert darauf, keine anonyme Onlineplattform zu sein, sondern pflegen persönliche Kontakte zu Gästen und Gastgeberin, sind damit nah und erreichbar.",
  hostSection1_3:
    "Wir kennen die Branche Zeitwohnen wie unsere Westentasche. Dadurch sind wir in der Lage, unseren Gastgeberinnen wertvolle Tipps für die Preisfindung der Immobilie zu liefern, eine Marktanalyse der gefragtesten Standorte für die Kurzzeitvermietung anzubieten, die perfekte Möblierung zu finden oder zu beraten, ob die Immobilie am besten als WG-Zimmer oder als Wohnung genutzt werden sollte. Wir wissen, was auf dem Markt Zeitwohnen gefragt ist.",

  hostSection2Headline: "Profitabel vermieten – so geht’s",
  hostSection2_1:
    "Sind Sie ambitionierter Vermieterin von Ferienwohnungen, Serviced Apartments, Monteurunterkünften, WG-Zimmern oder Pensionen? Oder haben Sie Interesse daran, in diese spannende Branche der Zeitvermietung einzusteigen? Unsere Plattform bietet Ihnen die Möglichkeit, Ihre Unterkünfte einem breiten Publikum zugänglich zu machen und so Ihre Auslastung zu optimieren.",
  hostSection2_2:
    "Ich unterstütze Sie bei der Kurzzeitvermietung von möbliertem Wohnraum und zeige Ihnen, worauf Sie achten müssen, um mehr Umsatz zu erzielen, den Stress zu reduzieren und gute Bewertungen von Ihren Gästen zu erhalten. Werden Sie Teil unserer Community und steigern Sie Ihren Erfolg im Vermietungsgeschäft!",
  hostSection2_3:
    "Erfahren Sie auch, warum Ihr Erfolg als Gastgeberin eng mit der passenden Möblierung Ihrer Immobilie verbunden ist und einen wesentlichen Einfluss auf deren Auslastung hat. Und entdecken Sie, warum es für Sie als Gastgeberin entscheidend ist, Ihre Zielgruppe genau zu kennen und gezielt anzusprechen. Ich berate Sie bei der Auswahl des Standorts für Ihre Immobilie zur Nutzung für Kurzzeitvermietung und zeige Ihnen Möglichkeiten auf, wie Sie Ihren eigenen Aufwand für die Gästeabwicklung effizient halten können.",
  hostSection2Button: "Vereinbaren Sie einen kostenlosen Gesprächstermin",

  hostSection3Headline:
    "Interesse, Ihre Einnahmen und Attraktivität als Gastgeber zu steigern?",
  hostSection3_1:
    "Entdecken Sie die Geheimnisse erfolgreichen Zeitwohnens! Erfahren Sie, warum die Vermietung an Geschäftsreisende besonders lukrativ ist und wie Sie Ihre Immobilie optimal für kurzfristige Vermietungen nutzen können. Von der richtigen Einrichtung bis hin zur gezielten Ansprache Ihrer Zielgruppe – wir zeigen Ihnen, wie Sie Ihre Einnahmen steigern und gleichzeitig die Zufriedenheit Ihrer Gäste erhöhen können.",
  hostSection3_2:
    "Warum es besser ist, sich auf monatliche Vermietungen an Geschäftsreisende zu konzentrieren:",
  hostSection3Panel1Headline: "Einhaltung gesetzlicher Bestimmungen",
  hostSection3Panel1:
    "Durch die Vermietung auf monatlicher Basis an Geschäftsreisende vermeiden Sie mögliche Probleme mit dem Zweckentfremdungsgesetz, dass die kurzfristige Vermietung von Wohnraum reguliert.",
  hostSection3Panel2Headline: "Stabilität statt Stress",
  hostSection3Panel2:
    "Entdecken Sie, warum die monatliche Vermietung an Geschäftsreisende Ihrem Immobiliengeschäft langfristig mehr Ruhe und höhere Einnahmen bringt!",
  hostSection3Panel3Headline: "Ruhe und Ordnung",
  hostSection3Panel3:
    "Die monatliche Vermietung sind in der Regel ruhiger und ordentlicher als Touristen oder Partygäste, was zu einer angenehmeren Wohnatmosphäre führt.",
  hostSection3Panel4Headline: "Firmengäste",
  hostSection3Panel4:
    "Geschäftsreisende, die Ihre Immobilie für längere Aufenthalte nutzen, sind oft professionelle und zuverlässige Gäste, die die Ruhe und Privatsphäre schätzen. Indem Sie sich auf monatliche Vermietungen an Geschäftsreisende konzentrieren, können Sie Ihren Aufwand reduzieren und gleichzeitig stabile Einnahmen generieren. Erfahren Sie mehr über die Vorteile dieses Ansatzes und wie Sie erfolgreich in der Kurzzeitvermietung tätig sein können.",
  hostSection3Headline_2:
    "Maximieren Sie Ihre Einnahmen und Attraktivität als Gastgeber!",
  hostSection3_3:
    "Profitieren Sie von unserem Stammkundenpotenzial, anstatt selbst nach Gästen zu suchen. Als führende Plattform im Bereich möbliertes Zeitwohnen für Geschäftsreisende verfügt unser Familienunternehmen Urbanbnb über eine breite Palette von Stammfirmen, die regelmäßig bei uns nach Unterkünften suchen. Indem Sie Ihre Immobilie über Urbanbnb vermieten, können Sie von dieser etablierten Kundenbasis profitieren und stabile Einnahmen generieren. Erfahren Sie mehr über bewährte Strategien, die Ihnen helfen, in der lukrativen Welt des Zeitwohnens erfolgreich zu sein.",
  hostSection3Button: "Vereinbaren Sie einen kostenlosen Gesprächstermin",

  hostSection4Headline: "Unser Podcast",
  hostSection4Text:
    "Willkommen zum Vermieter-Podcast für alle, die möblierte WG-Zimmer, Apartments, Ferienwohnungen, Monteurzimmer und Serviced Apartments vermieten möchten! Hier erhalten Sie wertvolle Tipps, Ratschläge und Einblicke, um Ihre Vermietungserfahrung zu optimieren und erfolgreich zu sein. Von der Einrichtung und Vermarktung bis hin zur Gästebetreuung – lassen Sie sich von Expertenwissen inspirieren und nehmen Sie Ihre Vermietung auf ein neues Niveau!",
  hostSection4Button: "Coming Soon",

  hostSectionAboutus1Headline:
    "Urbanbnb – ein erfolgreiches Familienunternehmen für Wohnen auf Zeit seit 1996!",
  hostSectionAboutus1Text:
    "Seit über zwei Jahrzehnten setzen wir Maßstäbe in der Branche des möblierten Zeitwohnens. Unser Ansatz ist frisch und innovativ: persönlich, nahbar und stets erreichbar für unsere Gäste und Gastgeberinnen. Entdecken Sie, wie wir Ihnen helfen können, Ihre Immobilie optimal zu nutzen und gleichzeitig die Zufriedenheit Ihrer Gäste zu maximieren.",
  hostSectionAboutus2Headline: "Claudia Urban",
  hostSectionAboutus2Text1:
    "Gründerin von Urbanbnb und Expertin sowie Visionärin für möblierte Vermietung.",
  hostSectionAboutus2Text2:
    "Meine Vision war und ist es, Menschen in einer fremden Stadt ein Zuhause zu geben. Seit mehr als 27 Jahren arbeite ich mit großer Freude und Motivation daran und habe Urbanbnb zu einer führenden Plattform für zeitgemäßes Wohnen gemacht. Mein Engagement und Fachwissen treiben Innovationen voran, um sowohl Gastgeberinnen als auch Gästen eine einzigartige und bereichernde Erfahrung zu bieten. Ich stehe für höchste Standards in der Branche und teile gerne meine Expertise, um Ihnen bei der erfolgreichen Vermietung zu unterstützen.",
  hostSectionAboutus2Text3:
    "Dank meiner engen Kontakte zu verschiedenen Unternehmen kenne ich die Anforderungen für die Anmietung möblierter Wohnungen für deren Mitarbeiter. Ich setze diese Wünsche und Anforderungen entsprechend mit meinen Gastgeberinnen um, was zu einer erfolgreichen Vermietung auf Zeit führt.",
  hostSectionAboutus2Text4:
    "So geht erfolgreiche Kurzeitvermietung – mit einem erfahrenen Profi an Ihrer Seite ein Kinderspiel!",

  hostSection5Headline: "3 Topgründe für die Kurzzeitvermietung!",
  hostSection5Text1: "Hohe Mieteinnahmen durch Kurzzeitvermietung",
  hostSection5Text2: "Jederzeit schnellen Zugriff auf die Immobilie",
  hostSection5Text3: "Gäste Zielgruppe definieren können",

  hostSection6Headline: "Wir begrüßen Sie auf unserem Portal",
  hostSection6Button: "Lernen Sie uns kennen",

  hostSection7Headline: "Und das sagen unsere Gastgeber",
  hostSection7Button: "mehr lesen",

  hostSection8Headline:
    "Ratgeberbuch für Vermieter für Wohnen auf Zeit und alle, die es werden wollen!",

  hostSection9Headline: "Mit Urbanbnb wird Gastgeber werden zum Kinderspiel!",
  hostSection9Button: "Vereinbaren Sie einen kostenlosen Gesprächstermin",

  hostSection10Headline1: "Kurze Frage, schnelle Antwort?",
  hostSection10Text1: "Wir sind per WhatApp für Sie da:",
  hostSection10Phone: "+ 49 (0) 1520 2105848",

  hostSection10Headline2: "Lieber eine Mail schreiben?",
  hostSection10Text2: "Auch kein Problem:",
  hostSection10Mail: "info@urbanbnb.de",

  // hostlogin
  login: "Login",
  register: "Register",
  registerHost: "Become a host",
  registerGuest: "Register guest",
  advertiseForFree: "Advertise your property for free!",
  weDoThatForYou: "We do that for you",
  tipsForHosts: "Tips for hosts",
  topicHospitality: "Theme hospitality",
  faqForHosts: "FAQ for hosts",
  faqForHostsSubHeadline: "Frequently asked questions from our hosts",
  rentDifferent:
    "With Urbanbnb rent your free rooms, apartments and accommodation differently!",
  mdLoginMsg1: `The increasing mobility of people in the labor market further increases the demand for flexible accommodation concepts in Germany. Furnished rooms and apartments in big cities are more popular than ever. Therefore Bnb is in Germany continues to grow. Take advantage of it. The rent furnished apartments and subletting rooms ensure an attractive extra income. Better than any side job. Earn money with your living space. Let Your room or apartment not wasted but rent relaxed if necessary to business and city visitors. And the best part, the effort furnished for rent is very small and manageable. Also you can incidentally earn good money - with a holiday accommodation rather than permanently.

  ### Soon you will greet your first guests.

  Decide for the alternative for permanent hire. Become Urbanbnb hosts and look forward soon to your first guests and the associated more money for your personal wishes.`,
  urbanbnbAdvantages:
    "Many advantages in Urbanbnb are quite obvious. They remain as Urbanbnb hosts free complete freedom and thus to work with other providers. The times when you want to rent your private accommodation, are you free choice as Urbanbnb hosts. Whether you within a week, a month, or want to rent only on weekends her room or the furnished flat: you decide when you want to enter their rooms or apartments as bookable in the diary. The best thing about the thing: you do not have to wait for your money and not chase because you get your money for the night always cash upon arrival by your host. When renting out furnished apartments, you also achieve a higher rent than an unfurnished rental period.",
  expectFromUsTitle: "WHAT YOU CAN EXPECT FROM US:",
  expectFromUsArticle_1_SubHeadline: "Personally there for you",
  expectFromUsArticle_1_Text:
    "As an Urbanbnb host, you can be sure that you always have a personal and accessible contact person. With us, the host is not a number that is created in the portal, but a valued partner. Not only do we ensure that your apartment is fully occupied, we are also at your side throughout the entire rental period. We do not leave you alone.",
  expectFromUsArticle_2_SubHeadline:
    "Benefit from our regular customer potential",
  expectFromUsArticle_2_Text:
    "Urbanbnb has been working in the field of temporary housing since 1996. Over the years we have counted many national and international companies among our regular customers. And we know our guests. We know exactly which guest fits best in which property. You can only expect that from a company that doesn't lose track and is close to the customer. As a small but powerful family business, we are very close to the action. Benefit from our experience on the temporary living market.",
  expectFromUsArticle_3_SubHeadline:
    "We let your property shine in the best light",
  expectFromUsArticle_3_Text:
    "Your room or apartment is your calling card. The guest books with you because of the good and detailed description, the meaningful pictures, a video that guides him through the property and a price structure in line with the market. Trust our experience. We support you in the preparation of a perfect synopsis of your property, because we know what is important.",
  expectFromUsArticle_4_SubHeadline: "Stay free",
  expectFromUsArticle_4_Text:
    "A cooperation with Urbanbnb should and will bring you advantages. We ensure the best possible utilization of your offer and take care of the complete marketing of your property in advance. The guest knows what to expect and comes to you ready to check in. All you have to do is hand over the keys. Good to know: With Urbanbnb you do not sign a sole contract. You can continue to work with other agencies at any time. And if you ever have other plans for your property, block the apartment or room with us. This is how renting works today.",
  hostTeaser: `Those who want to successfully rent out a place come to Urbanbnb`,
  urbanbnbHostMeans: "Urbanbnb host means",
  urbanbnbHostMeans_Article_1_Headline: "Trusted",
  urbanbnbHostMeans_Article_1_Text:
    "Over 70% of our hosts have been with us since our company was founded in 1996. Our hosts appreciate our work, the high occupancy rate, but above all that we have remained close and accessible over the years.",
  urbanbnbHostMeans_Article_2_Headline: "No Risk",
  urbanbnbHostMeans_Article_2_Text:
    "Registering as a host at Urbanbnb is completely free. We only charge a placement fee if we have successfully placed a guest for you.",
  urbanbnbHostMeans_Article_3_Headline: "Market price for your property",
  urbanbnbHostMeans_Article_3_Text:
    "A high rental price always looks great on paper for the host. But what good is a high rental price if it is too expensive for the guests? We have our finger on the pulse and offer you market-based pricing for your apartment. Trust us - we know the market.",
  urbanbnbHostMeans_AdditionalText: `Opt for the <span class="text-color-secondary">alternative to long-term rental</span>. Become an Urbanbnb host and look forward to your first guests and more money for your personal needs.`,
  hostLoginInfoTitle: "Become a good host, it is very easy",
  hostLoginInfoSubtitle:
    "For the worst case, it is good if you give your guest a few information at hand:",
  hostLoginInfo: [
    {
      imgUrl: "/assets/images/gastgeber/tipps/hausregeln.jpg",
      title: "Contact details",
      content:
        "Create a list of the most important telephone numbers in case of emergency such as before Next, hospital, police / fire. It is also helpful to inform the guest how you can be reached. Or a contact person you can trust. It is important that your guests know whom they can address any questions or problems. For emergencies your guest is grateful when a first aid kit is the bare necessities in the living room. Show your guest where he finds them.",
    },
    {
      imgUrl: "/assets/images/gastgeber/tipps/hausregeln.jpg",
      title: "Privacy",
      content:
        "Please be considerate of the privacy of their guests. Likewise, you may this also expect from him.",
    },
    {
      imgUrl: "/assets/images/gastgeber/tipps/hausregeln.jpg",
      title: "Residential climate",
      content:
        "Please ensure that your premises are always well ventilated and that the heating to the appropriate time of year works . For your guest should be clear where the heater is located and how it is to operate.",
    },
    {
      imgUrl: "/assets/images/gastgeber/tipps/hausregeln.jpg",
      title: "When children are guests",
      content:
        "Children should also be safe in your home. Therefore, please pay attention to the attached, for example, child safety at the outlets. If your apartment for children not suitable, you say that the guest and serve to prevent specific risks.",
    },
    {
      imgUrl: "/assets/images/gastgeber/tipps/hausregeln.jpg",
      title: "House rules",
      content:
        "For a harmonious combination, it makes sense, if you make your guest to certain rules carefully.",
    },
    {
      imgUrl: "/assets/images/gastgeber/tipps/hausregeln.jpg",
      title: "Smoking",
      content:
        "Smoking is not allowed in urbanbnb accommodations. Make best a small sign with the information in the living room .",
    },
    {
      imgUrl: "/assets/images/gastgeber/tipps/hausregeln.jpg",
      title: "Parking",
      content:
        "Show your guests where and parking available. Where charging for parking, please inform the guest.",
    },
    {
      imgUrl: "/assets/images/gastgeber/tipps/hausregeln.jpg",
      title: "Noise",
      content:
        "Ask your guests to keep the volume within reasonable limits. Discuss with your host, whether you bring other people is desirable in your home or not.",
    },
    {
      imgUrl: "/assets/images/gastgeber/tipps/hausregeln.jpg",
      title: "Domestic animals",
      content:
        "If you allow pets, tell your guests where the favorite can do his business (parks, green space in your area) and whether the guest has to eliminate the legacies of his dog.",
    },
    {
      imgUrl: "/assets/images/gastgeber/tipps/hausregeln.jpg",
      title: "Waste separation",
      content:
        "Your guest comes from another city or even from another country. He may not know how waste separation is regulated in your home course .Explain how that works in your town. Only this ensures that he does everything right.",
    },
  ],
  hospitalityTitle: "Hospitality - looks like this:",
  mdHospitality: `Even when creating your living space, you should describe the features as accurately as possible. Describe how your accommodation looks and see what the area (buses, trains, restaurants, etc.) offer for the guest. The detailed description of features contribute to the fact that many guests choose for your property.
Put your pricing per room or apartment. Either you rent on a daily basis and or for a monthly fee. Hold what you want to calculate for breakfast, parking, Internet or other services for the guest in advance about white communication and there is no local misunderstandings.
Frequently check the availability of your home through the availability calendar on Urbanbnb. Only in this way it is ensured that there is no overcrowding and the guest to the reserved period is also welcome to you.

If the guest announces itself: Preliminary learn all the important details such as its data, number of people, period and the price of the booking confirmation by Urbanbnb. These will be sent by mail. Then the host will call to arrange his exact arrival time with you personally. Of course you can also contact the guest by phone or mail directly equal. Arrange an arrival time that suits you and the guest.
Cleanliness: Make sure that all the rooms, for which your guest has access are properly cleaned safely. Please do not forget to keep the bathroom / toilet and the kitchen very clean. The towels and sheets that you provide should always be freshly laundered. Also, make sure that thoroughly dust is wiped ever, cleaned the mirror and the trash is emptied. Make room in the closet or in a dresser for your guest can stow his own clothes.

Arrival: Your guest has arrived. Please take a few minutes for the check in. The check required in forms to record the personal details of your guest, you can download as Urbanbnb hosts without problems in the Download Center on our website. There you will find the way also a lot more useful and important forms for your use. Then you pass the guest his house keys and get your accommodation costs.
Stay contact for your guest during his stay. But if this is not even possible, then make sure that your guest a number of a contact person gets (neighbor, someone from the family, etc). Of course, we are also still there. The guest can of course also welcome to contact in your absence with his questions to us.

The departure: Ensure that the departure of your guests as easily proceeds as its arrival. So the guest reserves you a positive memory and can book you one more time with you. You get the house keys back and ensure that the housing is passed back to you in an acceptable condition.

Changes: if your living room something should change, no problem. But always make sure that this is noted immediately in the features. Just so your guests can rest assured that they can expect the same thing you have inserted on the Urbanbnb page.
Take advantage of the great opportunity "from home" to make money with a strong mediation partner on your side.`,
  mdHostFaqList: [
    {
      id: 10,
      open: true,
      title:
        "I can already be found on the internet. What are the benefits of working with Urbanbnb?",
      content:
        "Do you already have a website for your apartment? That's perfect. But for more visibility and thus better utilization of your property, it is very important to position yourself more broadly in the network. With us you can reach more guests who will book your offer quickly, directly and legally. Our guests are mostly business travelers and companies looking for accommodation for their employees. Use our regular customer potential for more success in renting.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/en/Ich-bin-doch-bereits-im-Internet-auffindbar.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/en/Ich-bin-doch-bereits-im-Internet-auffindbar.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 20,
      open: false,
      title: "What makes Urbanbnb different from other agencies?",
      content:
        "You have come to the right place if you value reliable service and it is important to you to have a personal contact person. You have also come to the right place if you prefer to rent out your property on a monthly basis instead of welcoming a new guest every 2 days. Our guests come to your city for professional reasons and rent from 1 month and not by the day. Urbanbnb is a family-run company that has been very successful in the field of temporary accommodation since 1996. You can trust our service.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/en/Was-unterscheidet-Urbanbnb-von-anderen-Agenturen.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/en/Was-unterscheidet-Urbanbnb-von-anderen-Agenturen.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 30,
      open: false,
      title: "Can I work with other agencies and Urbanbnb?",
      content:
        "Yes, that's no problem if you still work with other agencies. The only important thing here is that you always keep your occupancy calendar carefully so that there are no overbookings.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/en/Kann-ich-mit-anderen-Agenturen-und-Urbanbnb-zusammenarbeiten.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/en/Kann-ich-mit-anderen-Agenturen-und-Urbanbnb-zusammenarbeiten.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 40,
      open: false,
      title: "How high is the booking volume at Urbanbnb?",
      content:
        "We have an occupancy rate of up to 90% for the year in many cities. Call us to find out how it is in your city.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/en/Wie-hoch-ist-das-Buchungsaufkommen-bei-Urbanbnb.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/en/Wie-hoch-ist-das-Buchungsaufkommen-bei-Urbanbnb.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 50,
      open: false,
      title: "Can the guest preview my offer before booking?",
      content:
        "No, unfortunately that will not work. This is because we have a very high demand from guests and the properties are very often still occupied by a guest until the day of the new rental. We don't want to burden the host with sightseeing tourism. Because if we allowed one guest to visit, we would have to allow other guests to do the same. This would keep the host busy making appointments for viewings. The guest looks at all the offers using pictures and videos on our website and then books them online.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/en/Kann-der-Gast-vorab-mein-Angebot-besichtigen-bevor-er-bucht.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/en/Kann-der-Gast-vorab-mein-Angebot-besichtigen-bevor-er-bucht.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 60,
      open: false,
      title: "How do I find the right price for my offer?",
      content:
        "Finding a fair market price for your offer is very important. Because if you are too cheap, the desired guests may not book with you. If you are too expensive, then too few guests will book with you. We support you in finding the right price and offer you a price structure in line with the market. Simply send pictures of your apartment or room and we will put together a price structure for you free of charge.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/en/Wie-finde-ich-den-richtigen-Preis-fuer-mein-Angebot.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/en/Wie-finde-ich-den-richtigen-Preis-fuer-mein-Angebot.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 70,
      open: false,
      title: "How exactly does the booking process work?",
      content:
        "First of all, your accommodation will be placed on our website in the best possible way and attention will be paid to optimal visibility. Our work consists of taking over the complete marketing for your property. You get the “finished” guest from us. He is well informed about what to expect on site and what he has to do to ensure that the keys are handed over and the rent is paid without a hitch. The guest receives all information such as availability, facilities, surroundings, prices and can immediately book your accommodation online, if available. As soon as a booking has been made, you will receive a booking confirmation by e-mail plus a short text message on your mobile phone. Your accommodation will then be automatically blocked in the occupancy calendar for the period.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/en/Wie-funktioniert-der-Ablauf-der-Buchungen-genau.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/en/Wie-funktioniert-der-Ablauf-der-Buchungen-genau.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 80,
      open: false,
      title: "Can I set the minimum stay for my guests myself?",
      content:
        "It is always possible to adjust the minimum stay yourself. We recommend a minimum booking period of at least 8 nights. This ensures that your effort with check-in and check-out is manageable. However, it is better to make your offer available for 1 month or more.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/en/Kann-ich-den-Mindestaufenthalt-meiner-Gaeste-selbst-bestimmen.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/en/Kann-ich-den-Mindestaufenthalt-meiner-Gaeste-selbst-bestimmen.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 90,
      open: false,
      title: "Is there a minimum term or notice period as a host?",
      content:
        "No, there is neither a minimum term nor a notice period. If you need your property yourself again, then block your offer in the occupancy plan. You simply log into your host account and block the desired period.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/en/Gibt-es-eine-Mindestlaufzeit-oder-eine-Kuendigungsfrist-als-Gastgeber.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/en/Gibt-es-eine-Mindestlaufzeit-oder-eine-Kuendigungsfrist-als-Gastgeber.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 100,
      open: false,
      title:
        "Personal contact with my guests is important to me, is this completely absent as an Urbanbnb host?",
      content:
        "No, of course you still have the opportunity to contact your guests after booking. You will receive all contact details of the guest.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/en/Der-persoenliche-Kontakt-zu-meinen-Gaesten-ist-mir-wichtig.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/en/Der-persoenliche-Kontakt-zu-meinen-Gaesten-ist-mir-wichtig.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 110,
      open: false,
      title: "How will I be notified if my space is booked by a guest?",
      content:
        "As soon as a guest has booked your offer, you will immediately receive a booking confirmation. This confirmation will be sent to you by e-mail and you will also receive a short message by SMS. At the same time, the guest receives a confirmation with your contact details. Our system will then automatically block your offer for this booked period so that there can be no overcrowding. So you don't have to worry about it.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/en/Wie-werde-ich-benachrichtigt.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/en/Wie-werde-ich-benachrichtigt.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 120,
      open: false,
      title: "Can I still occupy my accommodation myself?",
      content:
        "Yes, you can also rent out your property yourself. It is important that you always update the availability of your property via your occupancy calendar in our login area. If you block your offer on our site, no booking will be made. Once your offer has been activated, it can be booked by our guests at any time.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/en/Kann-ich-meine-Unterkunft-weiterhin-auch-selbst-belegen.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/en/Kann-ich-meine-Unterkunft-weiterhin-auch-selbst-belegen.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 130,
      open: false,
      title: "How is the rent paid to me?",
      content:
        "We have prepared the guest as best we can and he is informed that he will pay the first rent and the deposit in cash on arrival at your place. If a company has booked, they will usually want to transfer the accommodation costs. This is done by bank transfer to your account in advance.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/en/Wie-erfolgt-die-Bezahlung-der-Miete-an-mich.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/en/Wie-erfolgt-die-Bezahlung-der-Miete-an-mich.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 140,
      open: false,
      title: "What are the costs for me?",
      content:
        "Posting your offer on our site is completely free of charge. When arranging guests who have booked your offer, we only charge 10% net commission (plus VAT). And that only if the mediation is successful and only from the pure overnight price. Not from the additional income such as internet, cleaning, parking, etc., which you can charge in addition to the rental price. So the division is that you keep 90% of the revenue and get 10% for our work and marketing.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/en/Welche-Kosten-entstehen-fuer-mich.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/en/Welche-Kosten-entstehen-fuer-mich.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 150,
      open: false,
      title: "How does Urbanbnb billing work?",
      content:
        "After successful guest placement At the end of the month you will receive an email with an overview of all bookings that have been made. Of course you can see the monthly statements, as well as current and past bookings in your host account. We will then debit our fee from your account by direct debit.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/en/Wie-funktioniert-die-Abrechnung-fuer-Urbanbnb.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/en/Wie-funktioniert-die-Abrechnung-fuer-Urbanbnb.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 160,
      open: false,
      title: "What do I do in case of overcrowding?",
      content:
        "Just make sure to keep your availability calendar up to date. In this way you can easily avoid overbooking and there can be no double occupancy. If it does happen because you forgot to block, then it is important to always react immediately. Inform us in good time about the double occupancy so that we can take care of the guest and offer him a rebooking. Together we will surely find a solution.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/en/Was-mache-ich-bei-einer-Ueberbelegung.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/en/Was-mache-ich-bei-einer-Ueberbelegung.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 170,
      open: false,
      title: "What happens if a guest cancels?",
      content:
        "Plans are subject to change. If a guest wants to cancel, he must always inform us - Urbanbnb. If the guest informs you directly about the cancellation, please let us know. We can then immediately activate your accommodation for new inquiries on our website. Of course you have the possibility to charge the guest for your damage within the framework of the cancellation conditions.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/en/Was-passiert-wenn-ein-Gast-storniert.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/en/Was-passiert-wenn-ein-Gast-storniert.mp3",
          type: "audio/mpeg",
        },
      ],
    },
    {
      id: 180,
      open: false,
      title: "If I decide to work with Urbanbnb, what are the next steps?",
      content:
        "To become a host, simply register your property via the host registration on our website: https://www.urbanbnb.de/gastgeberlogin?lang=de. Write something about your offer such as location, facilities and description of the accommodation and upload your pictures. Then enter your free periods and you're good to go. If you ever want to make changes to the text, exchange images or enter blocks, you can do this yourself at any time. As soon as your registration is complete and you put your offer online, you can immediately be booked online as a host at Urbanbnb. If you need help or tips when creating, then send us an email or contact us via WhatsApp.",
      audio: [
        {
          id: 0,
          src: "/assets/media/faq/gastgeber/en/Wenn-ich-mich-fuer-die-Zusammenarbeit-mit-Urbanbnb-entscheide.ogg",
          type: "audio/ogg",
        },
        {
          id: 1,
          src: "/assets/media/faq/gastgeber/en/Wenn-ich-mich-fuer-die-Zusammenarbeit-mit-Urbanbnb-entscheide.mp3",
          type: "audio/mpeg",
        },
      ],
    },
  ],
  mdHostFaq: "",

  // hostmessage
  hostMessageTitle: "Your questions and opinions are important for us.",
  yourMessage: "Your Message",
  sendMessage: "Send Message",

  // pwreminder
  pwReminder: "Password Reminder",
  pwReminderMsg: "Forgot your password?",
  pwReminderModalMsg:
    "You will get a password reminder if an account exists under the specified mail.",

  // create offer
  createOffer: "Create Offer",
  offerMsg: "Please select a booking period to create an offer.",
  offerSuccessMsg: "Your offer was sent successfully.",
  sendMail: "Send E-Mail",

  // favoriteDropdown
  favorites: "Favorites",
  share: "Share",
  manageFavorites: "Manage favorites",
  deleteAll: "Remove all",
  noFavorites1: "No favorites selected. Click on",
  noFavorites2: "to favorite an accommodation.",

  // Details
  roomType: "Room type",
  roomtypeFor: "Accommodates",
  roomtypeForTooltip:
    "If you book the object as an individual, you will get the object for sole use, regardless of whether there are more beds.",
  roomSize: "Size",
  objectLocation: "Location",
  roomtypeHeading: "Description of the accommodation",
  photos: "Photos",
  panoramaHeading: "360° - Views",
  panoramaMsg:
    "You can rotate 360° in the following image. To do this, click on the image and move the mouse with the mouse button pressed. The forward/back arrows in the picture take you to the next position or view in the room or apartment.",
  ratings: "Ratings",
  resetTimespan: "Reset booking period",
  backToResults: "Back to Results",
  favoriteRoomtype: "Add as favorite",
  isFavorite: "Favored",
  moreInfos: "More information",
  stillUnsecure: "Not sure yet? <br/>Our solution: A trial month.",
  toAccommodation: "To the accommodation",
  toProvideMoreSecurity:
    "To give you more peace of mind, we've developed a special offer: <em>Book the apartment for just one month</em> and test it out on-site. Think of it as a <em> trial month</em>, during which you can experience the accommodation without any obligation. If you're satisfied afterward, there's nothing stopping you from extending your stay. This way, you can get a clear picture of the apartment without committing long-term. Trust in our years of experience, the security of verified properties, and our personal dedication – Urbanbnb is your reliable partner for furnished temporary living.",
  bookATestingmonth: "Book a test month",
  payment: "Payment",
  paymentTooltip:
    "Payment takes place on arrival or as bank transfer to the host. When booking more than two months: costs for the 1st month and deposit paid in cash on arrival. Following months cash one month later than actual arrival day.",
  blockingAdGuestTooltip:
    "During the 'Arrival and Departure Blocking' no arrivals or departures can take place. You can, however, create bookings that span over this blocking period.",
  openRoutePlanning: "Open in larger View (Route planner)",
  youtubeCookieNotAcceptedModalTitle: "Youtube Cookie not accepted",
  youtubeCookieNotAcceptedModalText:
    "Youtube videos cannot be displayed because cookies were not accepted. Please open the cookie settings and accept the 'Youtube' cookie.",
  youtubeCookieNotAcceptedModalButtonText: "Open Cookie Settings",
  onlineVisitTitle:
    "Online viewing available – watch the video now & experience the property live!",
  onlineVisit: "Online viewing",
  onlineVisitDescription:
    "What does “online viewing” mean? We don’t offer on-site visits – but with our video you still get a realistic impression! The tour shows you every room, the amenities and the atmosphere as transparently as possible – all from the comfort of your home. Ideal for guests traveling from afar or who need to decide quickly. Just start the video – and experience firsthand what awaits you.",
  // persons
  guests: ["Guest", "Guests"],
  adults: ["adult", "adults"],
  children: ["child", "children"],
  persons: ["Person", "Persons"],
  titles: ["Mr", "Ms", "Other"],

  //extensionOption
  extensionOption: "renewal option",
  extensionOptionCredit: "Paypack for renewal option",
  extensionOptionTooltip:
    "If you make a booking of more than 1 month, then it can be assumed that you want to rent the accommodation after your booking period. In this case we offer the extension option, which guarantees you that the reserved object is blocked for you in the connection period and cannot be booked by any other guest during the option. This service is initially subject to a charge - but the costs will be offset against a subsequent booking. If you make a subsequent booking in the same accommodation, there are no additional costs.",

  // prices / Price View
  price: "Price",
  prices: "Prices",
  roomPrice: "Room price",
  cleaning: "Cleaning Fee",
  cleaningIntermediate: "Intermediate cleaning",
  cleaningIntermediateTooltip:
    "The fee for the intermediate cleaning applies if your host cleans the accommodation either every 14 days or at least once a month for permanent stays.",
  cleaningFinal: "Final cleaning",
  cleaningFinalTooltip:
    "The final cleaning, which is usually carried out more extensively at the end of the stay, is charged independently of an intermediate cleaning. This fee only applies if you book more than 20 nights. Shorter day bookings do not pay for final cleaning.",
  onlineDiscount: "Online discount 5%",
  total: "Total",
  totalPrice: "Total price",
  depositOnArrival: "Deposit on arrival",
  depositInfo: "Deposit Information",
  deposit: "Deposit",
  depositAmount1: "The deposit is",
  depositAmount2: "of the room price",
  perDay: "per day",
  perMonth: "per month",
  perPerson: "per person",
  overnight: ["Overnight stay", "Overnight stays"],
  shortTimeBooking: "Short time booking",
  shortTimeBookingTooltip:
    "A unique addition is incurred if the booking period is shorter than the minimum booking length of the object.",
  bookObject: "Book object",
  bookingValidationFailed: "Booking not possible",

  // price info
  trafficConnection: "Traffic connection",
  tipsForArea: "Tips for the surrounding area",
  mdDetailsPriceHints: `
#### Please note:

The costs listed in the booking confirmation such as the accommodation costs, deposit, cleaning fees, as well as any costs for the extension option are to be transferred to the host before arrival. Please discuss the payment with the host before your arrival or ask for the host's bank details. The transfer of the costs stated in the booking confirmation must be received in the host's account 1 day before arrival. If a transfer of the costs is no longer feasible due to time constraints because of last-minute booking, please pay the amount in cash to your host on site upon arrival.


#### Deposit on the booking confirmation:

Should your booking or arrival have been made more than 14 days before arrival, the host reserves the right to charge a deposit of 30% of the rental amount as a down payment on the booking. This also applies to bookings by guests whose place of residence is abroad. If you have any queries regarding bank details, please contact your host. You will find the contact details in the booking confirmation.
 

#### Payment of accommodation costs:

For bookings of 2 months or more, payment of accommodation costs is always monthly.
 

#### Information about cleaning:

Some hosts charge an intermediate cleaning ( 14 days basic cleaning).
Other hosts only charge for final cleaning, in which case cleaning during the stay is the guest's responsibility.
 

#### Bed linen and towels:

This is an initial provision which includes the bedding, as well as pillows and sheets.
to bring along.
`,
  mdRelocationMsg:
    "All of our furnished apartments are eligible for official address registration (“Anmeldung”). After booking, your host will provide the necessary landlord confirmation document (Wohnungsgeberbestätigung), which is required for city registration or visa applications.<br><br>Learn more about relocation, visa support, and registering your address in Germany: [Relocation & Visa – How it works](/page/de/relocation).",

  // related roomtypes
  relatedRoomtypes: "Related accommodations",

  // AddressSearch
  chooseAddress:
    "Please enter the address and accept the most suitable proposal.",

  // address
  address: "Address",
  addressNumber: "Object number",
  addressType: "Object type",
  targetAddress: "Destination address (optional, if known)",

  // filter
  roomtype: "Room type",
  room: "Rooms",
  flat: "Apartment",

  // sorting
  sortBy: "sort by",
  distance: "distance",

  // comments
  rating: "rating",
  noRatings: "Not enough ratings",
  noComments: "No comments yet",
  averageRating: "Total rating",
  cleanlinessRating: "cleanliness",
  friendlinessRating: "friendliness",
  receptionRating: `reception`,
  featureRating: "features",
  readComments: "Read guests comments",
  cleaningPrice: "Cleaning charge",
  dynamicCleaningPrice: "Intermediate cleaning fee",
  staticCleaningPrice: "Final cleaning fee",
  depositMsg:
    "Your host will charge a deposit for security and key about 30 percent of accommodation price at arrival. This deposit will be paid to the host against receipt at arrival. You will get back the deposit by returning key and accommodation correctly. Please consider that only the return of the key implies vacation of the object legitimately. In other case, the object and if necessary the replacement for the key have to be paid further. So please return the key at the day of departure.",
  commentMsg:
    "Why you can trust our ratings: Only guests, who have booked with urbanbnb and have spent the night in the accommodation are allowed to rate. So the ratings always came from real guests, like you.",

  // booking steps
  loginStep: "Login / Register",
  smsStep: "SMS - authentication",
  book: "Booking",
  bookArticleText:
    "Find the perfect accommodation, tailored to your wishes and ideas. It doesn't matter whether it's a small guest room or a generously equipped apartment.",
  bookingLoginMsg:
    'If you already have booked our objects, please enter your email address and your password. If you forgot your password, we will send it with the "Forgot password"-function to your email adress deposited in our system. If necessary please look at your junk- or spam folders.',

  // booking header
  bookingPriceHint:
    "(To pay at arrival to the host in cash or if necessary in advance transfer. The deposit is about 30 percent of the accommodation price.)",

  // user details
  name: "Name",
  username: "Username / E-mail",
  firstname: "Firstname",
  lastname: "Lastname",
  title: "Title",
  company: "Company",
  street: "Street",
  houseNr: "House number",
  postcode: "Postcode",
  city: "City",
  town: "Town",
  country: "Country",
  email: "E-mail",
  email2: "Second E-mail",
  email2Tooltip:
    "If you want to have the booking confirmation to another email address, please sign up here.",
  oldPassword: "Old password",
  password: "Password",
  newPassword: "New password",
  passwordConfirm: "Confirm password",
  mobile: "Phone number", //"Mobile number",
  mobileNumber: "Mobile number",
  phone: "2. Phone number", //"Phone number",
  phonenumber: "Phone number",
  mobileSMS: "Sms phone number",
  newsletter: "Newsletter",
  allowNewsletter: "I would like to receive occasional information by e-mail.",
  fax: "Fax",

  // userchange
  mdUserChangeMsg:
    "Note:   \n If you change your account data, you have to confirm it with your password.",

  // register
  registerNow: "Register now without obligation",
  guestRegister: "Guest register",
  hostRegister: "Host register",
  guestRegisterInfo:
    "Please enter your contact data for the guest registration.",
  hostPhoneRequired:
    "The phone number is required for the booking confirmation. It will only be given to guests after a booking has been made, so that they can coordinate their arrival with you. The phone number therefore does not appear anywhere on the Internet or to a third party.",
  mdAcceptHostTerms: `I confirm that I have read, understand and accept the [AGBs](/assets/pdf/Gastgeber_AGB_en.pdf) for hosts, the [Cancellation Policy](/assets/pdf/Gastgeber-Widerrufsrecht_en.pdf) and the [Privacy Policy](/assets/pdf/Datenschutzerklaerung_en.pdf).`,
  yourAdvantages: `### Your advantages at urbanbnb

  - More flexible than permanent rental
  - Higher revenue
  - No rental rights disputes
  - Hosts instead of landlords
  - You define the minimum booking period yourself
  - You set the prices yourself

And the best - the item entry is completely free. We charge only 10% net service fee for a successful guest book from the pure accommodation price. So without any extra amenities like internet, cleaning, washing machine, parking etc.

**Create your object and activate it online and start the booking.**`,

  // Cancellation
  cancellationMsg:
    "Note on cancellation insurance: Protect yourself! After completing the booking, you can take out cancellation insurance.",
  cancellationMsg2:
    "Note on cancellation insurance: Because I can change plans: secure your booking with cancellation insurance. Scroll down in the text for more information and if you would like to take out cancellation insurance.",

  // smsAuth
  smsAuthMsg:
    "Please enter a mobile number to request the SMS authentication code. This code will be sent via SMS to the specified mobile number. Please enter this code in the next step to proceed with the booking.",
  checkData: "Check your contact data and request the SMS-confirmation code.",
  changeUserInfo: "Change user data",
  saveChanges: "Save changes",
  mobileForAuth: "Mobile number for SMS-authentication",
  onlyAuth:
    "Only for confirmation, will not be saved and does not have to be the mobile number of the guest",
  authcodeHint:
    "Please enter the four-digit code you have just been sent on your mobile number.",
  confirmationCode: "Confirmation code",
  getAuthCode: "Request confirmation code",
  submitAuthCode: "Send confirmation code",
  useNewNumberMsg:
    "You didn't yet receive a confirmation code on your phone? Please wait about 2-3 minutes. Depending on your phone provider it can take some time until the code is sent. If you mistyped while entering your phone number you can request a new confirmation code.",
  useNewNumber: "Request new confirmation code",
  smsUnreachableMsg:
    "The SMS-Gateway is currently not available. Please enter the following code instead:",

  // booking
  finishBooking: "Finish booking",
  bookNow: "payment required by booking",
  subscribe:
    "I want to get occasional information about new features of the portal.",
  wantsToRate: "I will rate the object after visiting.",
  readAGB: "I have read, understand and accept the [AGBs](/page/en/agbs)",
  readPrivacyPolicy:
    "I have acknowledged the [privacy policy](/page/en/datenschutz).",
  bookingErrorMsg:
    "Dear guest, the booking of the object in the selected period is not possible because another guest has taken a booking at the same time. Please choose another object or another booking period. Thank you.",

  // booking confirm
  remarks: "Remarks",
  remarkTooltip:
    "Please indicate whether you plan to bring pets, as they will cost extra. Please also read the AGBs.",
  acceptCancellationPolicy: "Renounce of withdrawal period",
  acceptCancellationPolicyTooltip:
    "I expressly request and expressly agree that you will begin the execution of the service, which is the subject of the contract to be concluded, before the end of the revocation period. Furthermore, it is known to me that I am already with complete fulfillment of the contract by you the legal right of withdrawal right.",

  // bookingInfo
  bookingConfirmation: "Booking confirmation",
  showBookingConfirmation: "Show booking confirmation",
  mdBookingConfirmationMsg: `Welcome – and congratulations on your booking!  

We’re delighted to let you know that your reservation is **now confirmed and binding**.  
Your host is already looking forward to welcoming you soon. For your convenience, all the important details can also be found in your **booking confirmation email**.  
  
By confirming your booking, you’ve also agreed to our **General Terms and Conditions (GTC)**, including the cancellation policy. You can read them anytime here:
(https://www.urbanbnb.de/page/en/agbs?lang=en#agbs_08)[https://www.urbanbnb.de/page/en/agbs?lang=en#agbs_08]
  `,
  summary: "Summary",
  addressDetails: "Object data",
  hostDetails: "Host data",
  bookingDetails: "Booking details",
  requiredFeature: "(Required Field)",
  paidFeatures: "Chargeable Features",
  paidFeature: "Chargeable Feature",
  mdPaymentInfo: `#### DEPOSIT:
  Your host will charge you a security deposit and key deposit of 30% of the accommodation price. This deposit is paid in cash upon arrival against receipt to the host. The deposit will be returned after proper return of the keys and rental property. Please note, that only the key return legally means the evacuation of the object. Otherwise, the overnight costs will be charged until the key has been returned. The cost of a key replacement may be charged. Therefore on the day of departure simply return the key :-).

  #### PAYMENT:
  The amount is payable upon arrival to the above host in cash or by pre-payment if the host allows this. Before the move-in and after the move-out, an object check will take place with you by the host. It is transferred cleanly and should be given in the same state. In the case of a non-correct return of the rented property, the host reserves the right to charge for damages or an excessively polluted rental property or to settle the deposit due on arrival. Please clarify this with your host directly.

  Important: Please call the hotel by phone prior to arrival. Host your expected time of arrival. There is no guarantee for the timely transfer of the object, therefore absolutely necessary to clarify directly with the host.

  We wish you a pleasant journey and a pleasant stay.

  If you have any questions or need further information, please do not hesitate to contact us via WhatsApp at <a href="https://wa.me/4915202105848" target="_blank">+49 1520 210 5848</a>.

  Many greetings send you the team of urbanbnb`,
  insuranceComment:
    "You have subsequently the opportunity to conclude an optional travel insurance. This is a listing of the ERV Europäische Reiseversicherung AG. The order, the payment and the settlement of travel insurance occures exclusively and directly to the ERV AG and on their payment systems. Therefore Urbanbnb provides only the web interface. This is a service information, so you have noticed it.",
  travelCancellationInsurance: "Travel insurance",
  mdInsuranceMsg: `For a carefree and safe stay we recommend the travel insurance of the ERV. It protects you in cases of illness and other possible risks from withdrawal and termination costs.`,

  // guest
  bookingOverview: "Booking overview",
  currentBookings: "Current bookings",
  expiredBookings: "Expired bookings",
  bookAgain: "Book accommodation again",

  // hostChange
  yourAccount: "Your account",
  toYourAccount: "To your account",
  addressOverview: "Object overview",
  mdAddressOverviewTextInfo: `### Object overview (various buildings / houses)

  Here, you first place your building, in which the room or apartments are located. In a later step, you create the individual accommodations (rooms / apartments). If you have several buildings, please create them as individual objects.`,
  quarters: "Accommodations",
  beds: "Beds",
  messageCenter: "Message-center",
  contactData: "Contact data",
  bankDetails: "Bank connection",
  manager: "Manager name",
  managerContact: "Manager contact information",
  managerEmail: "Manager E-Mail",
  managerTitle: "Management of the properties",
  mdManagerMsg:
    "If you have a supervisor for your objects, which handles the rental, makes contact with the host, the key passes, etc., then you can register it here. Contact details are received in the booking confirmation. Please insert Mobil or E-Mail.",
  changeBtnMsg:
    '(The "Save"-Button only becomes active (blue) once all required fields are filled.)',
  mdHostChangeMsg:
    "Note:   \n If you change your account or bank data, you have to confirm it with your password.",
  smsNotification: "SMS notification",
  mdSmsNotificationMsg:
    "We offer the service, that you will get notified with an sms for every booking. If you want to use this feature, please enter your number here.",
  backToPublish: "Back To Publish",

  //hostBankData
  bankAccountHolder: "Bank account holder",
  accountNumber: "Account number",
  bankCode: "Bank code",
  bankName: "Bank name",
  bankIBAN: "IBAN",
  bankBIC: "BIC-Code",
  sepaMandate:
    "Select payment method and, if necessary, debit authorization (SEPA mandate)",
  mdSepaInfoMsg: `We always create our host accounts on the 24th of the month, which you will receive by e-mail as a .pdf attachment in the form of a financial statement. Please check them and if necessary, make any changes if a guest bill is incorrect.

  When paying by invoice, please transfer the invoice amount and, in the case of direct debit, we book our fee from your account a few days later. You do not have any work and can return direct debits 8 weeks after debiting without reason. This makes SEPA direct mails safe and uncomplicated.`,
  invoiceConfirm: "I transfer the invoice amount after receipt of the invoice",
  debitConfirm:
    "I would like to participate in the direct debiting process and hereby give urbanbnb the permission to collect the monthly fees by direct debit.",

  // hostAddresses
  addAddress: "Add object",
  addressNameTooltip:
    "Please fill in a name/title for this object (e.g. guest room in Leonberg, 2-room apartment in Berlin-Pankow, guest house in Ostfildern, pension in Cologne centrum) ... It is possible to add multiple objects with different titles. Further in the process you can add one or more accommodations. That are the rooms or apartments.",
  deleteAddress: "Delete object",
  deleteAddressMsg: "Do you really want to delete the object?",

  // hostAddressProperties
  object: "Object",
  properties: "Properties",
  propertiesAndLocation: "Properties / Location",
  location: "Location",
  invoices: "Invoices",
  nameOfObject: "How should your object be advertised",
  countryOfObject: "In which country is your object located",
  cityOfObject: "In which city is your object located",
  addressOfObject: "Address of your object",
  addressNotFound: "Address not found",
  trafficConnectionMsg: `Please describe all information how a guest can use public transport, parking situation on site (own parking, kind or parked on the street, it costs something, resident parking etc).
  Note also how far to the bus / train by the meter, which bus / train then goes where, how far is it to the center. Are there any known companies nearby - please specify with km distance there. Bicycle parking?`,
  trafficConnection_de: "Traffic connection - german",
  trafficConnection_en: "Traffic connection - english",
  tipsForArea_de: "Tips - german",
  tipsForArea_en: "Tips - english",
  currencyOfObject: "Currency of your object",
  activateMapBoxCookie:
    "Please activate the Mapbox cookie. You can do this through the Cookie button in the rightern Sidebar.",

  // hostAddressRoomtypes
  roomtypes: "Accommodations",
  mdRoomtypesInfo: `### Accommodation (rooms and apartments)

  Here you place your one or the different rooms and apartments within an object / building. If you have several identical rooms, you can only add one of them, and you can add "rooms of the same type" in a later step, which is to say the number of rooms in this room.`,
  addRoomtype: "Add accommodation",
  editRoomtype: "Edit accommodation",
  hideRoomtype: "Hide accommodation",
  deleteRoomtype: "Delete accommodation",
  noTitle: "Without title",
  deleteRoomtypeMsg: "Do you really want to delete the accommodation?",
  hideRoomtypeMsg:
    "Afterwards the accommodation will not be found by searching. To make it visible again the accommodation has to be re-published.",
  roomtypeHidden: "Accommodation is hidden",
  roomtypeVisible: "Accommodation is public",

  // hostAddressBookings
  bookings: "Bookings",
  guest: "Guest",
  arrival: "Arrival",
  departure: "Departure",
  days: "Days",
  noBookings: "No bookings exist",
  backToBookingOverview: "Back to booking overview",

  // bookingView
  guestContact: "Guest contact information",
  reservationDetails: "Reservation details",
  priceDetails: "Price details",

  // hostAddressInvoices
  rent: "Rent",
  invoice: "Invoice",
  commission: "Commission",
  invoiceDate: "Invoice date",
  accountingPeriod: "Accounting period",
  showInvoice: "Show invoice",
  noInvoices: "No invoices yet",

  // hostRoomtype
  quarter: "Accommodation",
  description: "Description",
  media: "Photos and videos",
  features: "Features",
  bookingTimes: "Booking periods",
  name_de: "German short description",
  name_en: "English short description",
  description_de: "Description german",
  description_en: "Description english",
  backToRoomtype: "Back to accommodation",
  preview: "Preview",
  previewMode: "Preview mode",
  previewFailMsg: "The preview is only possible when the prices are complete.",
  publishRoomtype: "Publish accommodation",
  roomtypeGotUnpublishedMsg:
    "The accommodation got deactivated by your changes and has to be published again. Please make sure that all the entries in the left menu have a green checkmark. Without re-publication the accommodation will not be visible online.",
  roomtypeGotUnpublishedTitle: "Accommodation deactivated",
  mdRoomtypePublished: `Your accommodation is now online and can be booked by guests.${s}
  We look forward to many bookings with You.

  Your urbanbnb Team`,
  lastMinute: "Last minute booking",

  staticFeatures: {
    residenceRegistration: "Residence registration possible",
    residenceRegistrationTooltip:
      "Hosts are required by law to allow residency registration.",
    invoicePossible: "Invoice possible",
    invoicePossibleTooltip:
      "All our hosts will of course issue you a tax-deductible invoice. Usually this is done without VAT for private individuals. However, if the host is marked as a commercial provider, the invoice will be issued with VAT.",
  },

  // hostRoomtypePublish
  cantPublish:
    "Your Accommodation can't be published, because the information is not complete. Please ensure that all entries in the menu on the left are marked with a green checkmark.",
  mdPublishNeedsBankInfo: `**Please choose your payment method and enter your bank account into your account.**`,
  toDetailsPage: "To details page",
  toObjectsPage: "Your objects",
  isPublished: "Accommodation published",

  // old hosts with >10%
  mdNearlyFinishedOldHost: `**Almost finished**

  Setting your advertisement is free. We only charge a service fee on the basis of the pure accommodation price for a successful guest booking of your property. That means service charges which are paid to you in addition, such as Internet, cleaning, breakfast, parking, pet etc. are of course your money.`,

  // new hosts with 10%
  mdNearlyFinished: `**Almost finished**

  Publishing your advertisement is free. We only charge a service fee of 10% (plus VAT) of the pure accommodation price for a successful guest booking of your property. That means service charges which are paid to you in addition, such as Internet, cleaning, breakfast, parking, pet etc. are of course your money.`,

  // new hosts with only direct debit
  mdFeeDebitMsg: `**Fee settlement**

  We always draw up our host accounts on the 24th of the current month, which you then receive by email as a pdf attachment in the form of a taxable invoice. Please check this and let us know of any changes that may be required if a guest account is incorrect. In order to make things easier for you and us, we would like to have our fees paid by direct debit. This will also save us having to monitor incoming invoices. In addition, this is a security feature for guests, where we know that you actually exist as a host and you have a bank account. Please enter your bank details here. By doing so, you give us permission to collect the monthly incurred fees by direct debit until further notice. You can object to this permission in writing at any time. Direct debits can also be returned eight weeks after being cleared without giving a reason. This makes SEPA direct debits secure and uncomplicated for you.`,

  // hostRoomtypeProperties
  roomtypeNameMsg: `Please mention here the key features of your property. This is the heading about your entry and in the search the first thing the guest reads. Example of a text: "Guest room in Stuttgart-Möhringen near musical with Internet, TV, shower / WC and dividing kitchen, washing machine" or "1-room vacation apartment in Berlin-Tegel with TV, Internet, balcony, kitchenette, shower / wc, parking, close to suburban Train".`,

  // hostRoomtypeDescription
  descriptionMsg:
    "It is important to describe your object explicitly so that your future guests will get an exact idea of the accommodation. If you are offering television or internet for use, please specify which kind of TV or internet connection you offer (SAT, Cable, DVB-T, W-LAN, etc.). Please also describe the parking possibilities near the accommodation and which kinds of public transport are available.",
  mdDescriptionInfo:
    "**Please Note:** Please be aware that the description can only be saved once it has been entered in both German and English. The integrated translation buttons are available to assist you in translating the text.",
  incompleteMsg: "Not yet complete",

  // hostRoomtypeFeatures
  optionalFeaturePriceMsg:
    "When one of your services is included and you do not require an extra fee for it, leave the price fields blank.",
  noPaidFeaturesMsg: "No chargeable features selected.",
  mdFeaturePriceHint: `We recommend the following prices:`,

  // hostRoomtypePrices
  mdRoomtypePriceMsg: `The overnight price should correspond to your specified object. If you are unsure what price to charge, ask us. We will gladly prepare a price calculation for you.

  Our tip: A higher price will lead to a bad operating grade. Maybe you want to offer a lower price for your guests to indicate your object. After the first ratings you can still increase the price.`,
  cleaningInfo: "Info about cleaning",
  roomtypeIntermediateCleaningMsg: `If you clean your property yourself or have it cleaned every 14 days, please enter a sum here that the guest will pay.`,
  roomtypeFinalCleaningMsg: `This is always charged, regardless of whether you offer an intermediate cleaning or not. This takes place after the guest has moved out, so it is a one-off fee that the guest pays extra. Regardless of the duration and will be paid for upon arrival. Please enter this final cleaning fee here.`,
  mdRoomtypeCleaningMsg: `A final cleaning fee is always charged, once and shown at the time of booking, so that the guest is informed of the amount etc. and is paid at the same time on/before arrival.

14-day intermediate cleaning: This is optional. Is an organizational question, whether you want to or can do an intermediate cleaning. The advantage of an interim cleaning is that you can check your property at your leisure every 14 days and if there are undesirable developments or defects, you can react to them early on and inform us. We will then speak to the guest. Intermediate cleaning includes only a basic cleaning without dishes, possibly with a change of bed linen and towels.
    `,
  mdCleaningPriceMsg: `(Recommended cleaning fee for a guest room: 2 €/night and 30 €/month. Recommended cleaning fee for a flat: 4 €/night and 50 €/month. Correspondingly higher with a larger apartment.)`,
  mdFeaturePriceMsg: `Additional features such as internet, parking space, breakfast, etc. - please enter prices at the bottom left navigation item features at the bottom.`,
  childrenPriceMsg:
    "Children under 12 years pay 2 Euros per day and 30 Euros per month less than adults. This perk will be inclusive automatically if the number of children is specified.",

  // hostRoomtypeBookingOptions
  minDays: "min. booking period",
  maxDays: "max. booking period",
  oneIn3Days: "within 3 days",
  oneIn2Months: "within 2 months",
  mdMinBookingDaysMsg: `
  Tip: Many of our guests travel occupationally. ${s}
  We recommend for business reasons to set the minimum booking duration to atleast two days for rooms or five days for apartments. Otherwise You could have disproportionately high expenditures for check-in, check-out and cleaning.`,

  mdMaxBookingDaysMsg: `
  For the maximum booking period, please specify the number of days your object can be booked at most. This field can also be empty if the guests can book longer than a month.`,

  mdOneNightBookingMsg: `According to experience hosts do not like 1-day-booking guests. Because of that we give you the possibility to decide if you want to offer your object for 1 day. This is addressed to the hosts who want to house mechanics for many weeks. If, for example, a guest has only booked for 1 day within a 2 month period, the object is unavailable for the whole duration.

  Though if you want to offer 1-day booking with a maximum of 3 days in advance, you can enable that with this option: \"within 3 days"\

  One-day-bookings are optional and disabled by default.`,

  mdLastMinuteMsg: `Many of our business guests are booking shortly. For example, they are booking on Monday and arrive Monday evening. When you release booking last minute, it means that the guest choose your subject on the same day, and then can arrive the same evening (arrival in consultation with you). If this is ok for you, you should accept last minute booking, as this is a high occupancy rate. You will get an email and SMS, so you can immediately get in touch with the guest for consultation for arrival / key handover.`,
  allowLastMinute: "Allow last-minute booking",

  // hostRoomtypeRooms
  manageRooms: "Room Management",
  roomNumberOrName: "Room number or name",
  addRoomsOfThisKind: "Add rooms of this kind",
  deleteRoom: "Delete room",
  deleteRoomMsg: "Do you really want to delete the room?",
  mdRoomExplanation: `One room has already been created for You in the room management. It is displayed as number 1.

  If You don't want to add additional rooms just click on *'Next'*. You can change the room number/name with *'Edit'*, if You want use different names or numbers for Your accommodations.

  If You have several similar rooms or apartments you can create multiples of them here. Furthermore you can assign custom numbers or names to them to allow for easier differentiation in the booking calendar or to match your own naming scheme`,
  manageRoomMsg:
    "Basically, you can see the booking calendar in the room management and can submit your own booking blockings, for example, if you are on vacation.",

  // hostRoomReservations
  reservationCalendarShort: "Reservation calendar",
  reservationCalendar: "Reservation calendar / Booking blockings",
  booked: "Booked",
  blocking_ad: "Arrival- and departure blocking",
  blocking_full: "Full blocking",
  option: "Extension option",
  option_ok: "Extension option",
  blockingAdTooltip:
    "For example if you are on holiday for a week, you can rent the accommodation during this period anyway. You only have to be on-site for arrival and departure. So please specify here the lock on the period before and after the holiday.",
  blockingFullTooltip:
    "Please put the period in which your accommodation is not for rent. Reasons for this may be holiday, renovation, capital allocation or re-letting.",
  chooseBlockingType: "Choose type of blocking",
  blockingReason: "Blocking reason",
  blockingFrom: "Blocking from",
  blockingTo: "Blocking to",
  createBlocking: "Create blocking",

  ownBooking: "Own booking",
  backToReservationCalendar: "Back to reservation calendar",

  // hostRoomtypeMedia
  mdMediaInfo: `**Important:** Photos should always be landscape. If you are using mobile phone, please turn your mobile phone and please do not record in portrait format. Also make unusual photos, ie to the window, from the floor over the bed, from the corner from above the whole room. Please no photos taken in the dark. Daylight is better. Bathrooms / Wc - also here landscape format, small rooms can be easily taken from above from the corner out. Photos are your business card, so please take your time and create attractive photos.

  **Videos:** Guests are increasingly looking at sightseeing videos. Feel free to send us your home-made video. Simply record with your mobile phone, lasting about 10-15 seconds. Send the movie via email or best via whatsapp. We continue to process it and use it here. A video of your object we recommend you very much, because guests read less and less texts, but want to learn more visual information about the object. Therefore please create and send us. If you have a Youtube channel, you may also like to insert the Youtube video URL here yourself.`,
  addPhoto: "Add photo",
  addVideo: "Add video",
  addPanorama: "Add 360° photo",
  videoNotFound: "No video found",
  showInSlider: "Show large format on details page",
  showInSliderTooltip:
    "You can select the photos to be displayed on the details page as a large size. All other images are displayed in the image gallery of the details page in normal size.",
  addMediaItem: "Add new photo, video or 360° photo",
  uploadNewEntries: "Upload new photos/videos",
  mdVideoContact: `We would be pleased to upload the videos for you, please send us an e-mail to info@urbanbnb.de (mailto: info@urbanbnb.de). Then we will send you a personalized link to send us the video. We'll make the video for you.

  If you already have a Youtube URL, you can enter it in the following dialog.`,
  mdMediaTitleInfo:
    "You can edit the picture title before uploading. The title will be shown as picture title and mouse-over text. \n\n It should have keywords for search engines (e.g. accommodation-in-Stuttgart-centrum-01.jpg)",
  mdImageInfo:
    "You can choose which pictures should be shown in fullscreen at the top of the details page.\n\n Please ensure that the picture is large enough (Recommendation: 2500 Pixel width = approx. 1 MB file size).\n\nThe image size for 360° photos must be 3000 x 1500 pixels!",
  mdMoveInfo:
    "The order of the pictures can be changed by dragging them with the Move-icon.",
  mdUploadInfo:
    'Please click the button "Upload New Entries", after you have selected your photos for the upload.',
  noteImageUpload: "Hint: file upload",
  noteFilename: "Hint: filename",
  noteImagesize: "Hint: image size",
  noteImageorder: "Hint: image order",
  chooseFile: "Choose a file",
  defaultViewSelected: "Default view selected",
  chooseDefaultView: "Choose default view",
  previewSelected: "Preview image selected",
  choosePreviewImage: "Choose preview image",

  // cancellation
  cancelBooking: "Cancel booking",
  mdCancelMsg:
    "Please inform us about your cancellation in the following field or per mail and consider the terms of cancellation written in the [AGBs](https://www.urbanbnb.de/page/en/agbs?lang=en#agbs_08) and the costs which can be incurred by canceling.",
  cancelReason: "Cancel reason",
  cancelNow: "Cancel now",

  // complaint
  bookingComplain: "Submit a complaint",
  complaintReason: "Reason of complaint",
  complaintMsg:
    "You are not satisfied with your booking object? You have a reason to complaint? Please tell us in writing what is wrong. We will inform your host and try to communicate it.",
  hostComplaint: "I already informed my host about the complaint.",
  hostComplaintMsg:
    "It is often helpful to talk about your complaint with your host. In many cases problems can be solved and defects can be repaired immediately.",
  complaintLabel: "Description / Reason of complaint:",

  // rate
  rateBooking: "Rate accommodation",
  rateNow: "Submit rating",
  hostRatingHint:
    "For reasons of privacy we ask you not to mention the name of your host. Your own privacy is protected with a name abbreviation.",

  // extend
  bookingExtend: "Extend booking",
  extendMsg: "You want to extend your stay in the accommodation aside?",
  extendNow: "Extend now",

  // hostRoomtypeAdd
  descriptionOfRoomtype: "Heading of the accommodation",
  roomtypeNameTooltip:
    "Please give us a name/title of this special accommodation (room or apartment), e.g. guestroom with tv, shower/toilet, guest-citchen, internet or 1-room apartment with citchen, shower/toilet, tv, internet. This title will be shown in the result list. Forage for similiar accommodations and look at its title.",

  // blog
  blog: "urbanbnb Blog",
  blogDescription:
    "Discover urban temporary living with Urbanbnb: From furnished apartments in Stuttgart, Karlsruhe to Cologne and beyond. Our family business shares insights on temporary living, urban temporary housing concepts, subletting, as well as important aspects like tax-related questions, legal changes, and equipment trends.",
  blogSeoTitle: "Urban Temporary Living with Urbanbnb",
  blogSeo:
    "<p>In the dynamic world of temporary living, Urbanbnb presents an informative blog that extends across cities like Stuttgart, Karlsruhe, Cologne, and beyond. The family business shares its expertise on essential topics such as furnished apartments, temporary housing, urban temporary living concepts, and subletting.</p> <p>The blog not only provides insights into the latest developments in these cities but also addresses important aspects for landlords, including tax-related questions, legal changes, and trends in housing equipment. Urbanbnb positions itself as a reliable partner for contemporary living and informs its readers about all relevant facets of temporary living.</p> <p>The precise and understandable reporting allows readers to comprehensively inform themselves and understand the benefits of urban temporary living. With a focus on several cities, Urbanbnb offers a holistic view of the challenges and opportunities of temporary living in different urban environments.</p> <p>The blog texts are carefully researched, current, and provide clear insights into the world of contemporary living. Urbanbnb aims to offer not only temporary tenants but also landlords a valuable source of information. The blog serves as a platform for knowledge transfer, comprehensive advice, and a contact point for all those interested in the dynamic world of urban living.</p> <p>Urbanbnb stands out as a competent contact for contemporary living and strengthens its position through the continuous provision of relevant information. The blog is open to all interested parties and offers a rich source of knowledge and guidance for those considering temporary living in the mentioned cities.</p> <p>For more information and deeper insights into urban temporary living, we recommend visiting the Urbanbnb Blog.</p> <p>Press contact: Urbanbnb Press Team Email: <a href='mailto:info@urbanbnb.de'>info@urbanbnb.de</a></p> <p>About Urbanbnb: Urbanbnb is an established family business that specializes in temporary living and furnished apartments. With an urban temporary living concept, Urbanbnb offers flexible solutions for contemporary living in various German cities. More information can be found at www.urbanbnb.de.</p>",
  archive: "Archive",
  topics: "Topics",
  showAll: "show all",
  back: "Back",
  noMoreEntries: "No more entries",
  copiedToClipboard: "URL was copied to clipboard",

  // cookieNotice
  mdCookieNotice:
    "Cookies facilitate the provision of our services. By using our services you agree that we use cookies.",

  // coronaMessage
  coronaMessage: "Travel safely in Covid-19 times",
  coronaButton: "more Information",

  coronaTitle:
    "The world currently has an unsolicited guest - the Coronavirus.",
  mdCoronaMessage: `**Our Covid-19 precautions for your safety and the safety of your host:**
  ${s}

  All Rooms and apartments will be cleaned thoroughly before your arrival. Additional attention will be given to areas like bathroom, toilet, shower, kitchen aswell as bedside tables and devices for daily needs such as the remote control of the TV set.

  If you have booked an apartment your host will hand it over to you cleaned. During your rental period, you can arrange with your host that they will not enter the apartment for intermediate cleaning.

  On your arrival please keep the required safety distance of 1.5 meters and cover your mouth and nose. Your host will do the same. If possible, payment of the rent should be made cashless. In order to do that, please get in touch with your host to clarify the bank details for the transfer of the rent and deposit prior to your arrival. Also have the proof with you at the arrival.`,

  urbanLagerButtonText: "Need additional storage space?",
  urbanLagerTeaserText: "Now rent a private cellar or storage room in addition to the apartment – urban-Lager.de",
  errors: {
    generic: "An error has occurred",
    rate: "An error occurred while submitting the rating",

    "features.save": "An error occurred while saving the features",
    "host.change": "An error occurred while changing your data",
    translation: "The translation of the text failed",
    "translation.available": "The translation service is currently unavailable",
    "terms.accept": "Please accept the terms and conditions to proceed",
    "pdf.download": "PDF download failed",
    "media.delete": "An error occurred while deleting the media entry",
    "blocking.conflict":
      "The block could not be set as it overlaps with an existing booking or block",
    "address.create": "An error occurred while creating the address",
    "roomtype.create": "An error occurred while creating the accommodation",
    "room.save": "An error occurred while saving the room",
    "room.delete": "An error occurred while deleting the room",
    "email.existing": "Email has been used before",
    "email.email.": "The email address is not fully specified",
    "email2.email.": "The second email address is not fully specified",
    notValid: "The input is not valid",
    "email.invalid": "The email address is invalid",
    "phone.invalid": "The phone number is invalid",
    "email.required.": "The email address is a required field",
    "email.missing": "The email address is a required field",
    "lastname.required.": "The last name is a required field",
    "lastname.missing": "The last name is a required field",
    "firstname.required.": "The first name is a required field",
    "firstname.missing": "The first name is a required field",
    "title.missing": "The salutation is a required field",
    "postcode.required.": "The postal code is a required field",
    "postcode.missing": "The postal code is a required field",
    "street.required.": "The street is a required field",
    "street.missing": "The street is a required field",
    "city.required.": "The city is a required field",
    "city.missing": "The city is a required field",
    "mobile.required.": "The mobile number is a required field",
    "mobile.missing": "The mobile number is a required field",
    "value.tooSmall": "The value is too small",
    "password.minsize": "Password must be at least 6 characters long",
    "password.required": "The password is a required field",
    "password.missing": "The password is a required field",
    "passwordConfirm.missing": "The password confirmation is a required field",
    "password.mismatch": "Passwords do not match",
    "captcha.notActivated": "Please confirm that you are not a robot",
    "g-recaptcha-response.invalid": "The captcha verification failed. Please try again.",
    "privacyPolicy.notAccepted": "Please accept the privacy policy",
    oldPassword: "Your password is incorrect",
    "bankiban.match": "The entered IBAN format is incorrect",
    "bankbic.match": "The entered BIC format is incorrect",

    "sms.wrongcode": "Invalid confirmation code entered",
    400306: "The selected period is in the past",
    400903: "Invalid phone number provided",
    400913: "The email address you entered is invalid",
    401100: "Your login details are incorrect",
    401102:
      "Your account is currently blocked from online booking for various reasons. Please send us an email with your name and concern to: [info@urbanbnb.de](mailto:info@urbanbnb.de)",
    404101: "No accommodations selected",
    409703: "Rating submitted too early",
  },
  bookingValidation: (code, minDays, maxDays) => {
    switch (code) {
      case 100:
        return "Accommodation already reserved";
      case 200:
      case 201:
      case 202:
        return `Selected booking period falls below the minimum booking duration of ${minDays} nights. Please adjust your booking period or search for another accommodation.`;
      case 300:
        return `Selected booking period exceeds the maximum booking duration of ${maxDays} nights.`;
    }
    return null;
  },
  countries: {
    DE: "Germany",
    AT: "Austria",
    CH: "Switzerland",
    NL: "Netherlands",
    ES: "Spain",
    PT: "Portugal",
    GR: "Greece",
  },
  mediaTypes: {
    image: "Image",
    video: "Video",
    panorama: "360° Photo",
  },
};

let locale = { de: localeDE, en: localeEN };

/* Test completeness of translation */
if (config.env === "test") {
  const langs = Object.keys(locale);
  const keys = Object.keys(locale[langs[0]]);
  for (let i = 1; i < langs.length; i++) {
    const current = locale[langs[i]];
    const currentKeys = Object.keys(current);
    for (let j = 0; j < keys.length; j++) {
      if (currentKeys.indexOf(keys[j]) < 0)
        log.error("lang %s missing key %s", langs[i], keys[j]);
    }

    for (let j = 0; j < currentKeys.length; j++) {
      if (keys.indexOf(currentKeys[j]) < 0)
        log.error("lang %s has additional key %s", langs[i], currentKeys[j]);
    }
  }
}

type LocaleObject = typeof locale.de & {
  de: typeof locale.de;
  en: typeof locale.en;
  multiple: (identifier: keyof typeof locale.de, value: number) => string;
};

// select locale, use de as fallback
const selectedLocale: LocaleObject = assign(locale[lang] || locale.de, {
  de: locale.de,
  en: locale.en,
  multiple: (identifier: keyof typeof locale.de, value: number): string =>
    value === 1 ? locale[lang][identifier][0] : locale[lang][identifier][1],
});

export default selectedLocale;
